export const UI_TRANSLATIONS = {
  "English": {
    app_title: "Pokémon GO Search Builder",
    app_subtitle: "Build search strings visually",
    search_string: "Search String",
    search_placeholder: "Your search string will appear here...",
    filter_search_placeholder: "Search filters... (e.g., 'shiny')",
    stats_ivs: "Stats & IVs",
    types: "Types",
    type_effectiveness: "Type Effectiveness",
    special_status: "Special Status",
    evolution_buddy: "Evolution & Buddy",
    time_distance: "Time & Distance",
    size_gender: "Size & Gender",
    moves: "Moves",
    regions: "Regions",
    clear_all: "Clear All",
    copy: "Copy",
    copied: "Copied!",
    copy_has_issues: "Copy (Has Issues)",
    validation_error_title: "⚠️ This search won't work in Pokémon GO",
    validation_error_subtitle: "These combinations are impossible, but you can still copy if you want to experiment.",
    validation_why_label: "Why it won't work:",
    validation_fix_label: "✓ How to fix:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "Perfect Attack (15)",
    filter_3attack: "High Attack (12-14)",
    filter_4defense: "Perfect Defense (15)",
    filter_3defense: "High Defense (12-14)",
    filter_4hp: "Perfect HP (15)",
    filter_3hp: "High HP (12-14)",
    filter_0attack: "Zero Attack",
    filter_0defense: "Zero Defense",
    filter_0hp: "Zero HP",
    filter_shiny: "Shiny",
    filter_lucky: "Lucky",
    filter_shadow: "Shadow",
    filter_purified: "Purified",
    filter_legendary: "Legendary",
    filter_mythical: "Mythical",
    save_this_search: "Save this search",
    search_saved: "Search saved!",
    active: "active",
    light_mode: "Light mode",
    dark_mode: "Dark mode",
    translation_warnings: "Translation Warnings:",
    conflicting_filters: "Conflicting Filters",
    remove_spaces: "Remove spaces from search string",
    missing_ampersand: "Missing & between filters",
    use_commas: "Use commas between Pokedex numbers, not &",
    quick_searches: "Quick Searches",
    cp_ranges: "CP Ranges",
    pokemon_selection: "Pokemon Selection",
    pokemon_groups: "Pokemon Groups",
    insert_cp_range: "Insert CP ranges for PvP leagues",
    quick_insert_pokemon: "Quick insert Pokemon ranges and groups",
    saved_searches: "Saved Searches",
    import_searches: "Import searches",
    export_searches: "Export searches",
    delete_saved_search: "Delete saved search",
    storage_limit_reached: "Storage limit reached. Please delete some saved searches.",
    failed_import: "Failed to import saved searches. Please check the file format.",
    language: "Language",
    language_wip: "(WIP)",
    join_discord: "Join the Discord for updates, suggestions, and bug reports",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Caught Today",
    last_7_days: "Last 7 Days",
    last_30_days: "Last 30 Days",
    last_week: "Last Week",
    last_month: "Last Month",
    last_year: "Last Year",
    custom_age: "Custom Age",
    today: "Today",
    more_than_days_ago: "More than {days} days ago",
    days_ago: "{start}-{end} days ago",
    last_days: "Last {days} days",
    age_label: "Age {value}",
    distance_1000km_plus: "Distance 1000km+",
    distance_100km_plus: "Distance 100km+",
    include: "Include",
    exclude: "Exclude",
    custom_date_range: "Custom Date Range",
    examples: "Examples",
    invalid_format: "Invalid format. Use: number (e.g., 30), range (e.g., 0-7), or age format (e.g., age0-30)",
    generations: "Generations",
    pokemon_groups: "Pokemon Groups",
    gen_1_kanto: "Gen 1 (Kanto)",
    gen_2_johto: "Gen 2 (Johto)",
    gen_3_hoenn: "Gen 3 (Hoenn)",
    gen_4_sinnoh: "Gen 4 (Sinnoh)",
    gen_5_unova: "Gen 5 (Unova)",
    gen_6_kalos: "Gen 6 (Kalos)",
    gen_7_alola: "Gen 7 (Alola)",
    gen_8_galar: "Gen 8 (Galar)",
    all_starters: "All Starters",
    kanto_starters: "Kanto Starters",
    johto_starters: "Johto Starters",
    hoenn_starters: "Hoenn Starters",
    sinnoh_starters: "Sinnoh Starters",
    unova_starters: "Unova Starters",
    kalos_starters: "Kalos Starters",
    alola_starters: "Alola Starters",
    galar_starters: "Galar Starters",
    pseudo_legendaries: "Pseudo-Legendaries",
    eeveelutions: "Eeveelutions",
    quick_combos: "Quick Combos",
    quick_combos_info: "These buttons append filter combinations to your existing search string, allowing you to stack multiple combos together.",
    shiny_legendaries: "Shiny Legendaries",
    shiny_legendaries_desc: "All shiny legendary Pokemon",
    perfect_shadows: "Perfect Shadows",
    perfect_shadows_desc: "100% IV shadow Pokemon",
    high_iv_non_shiny: "High IV Non-Shiny",
    high_iv_non_shiny_desc: "3-4★ Pokemon that aren't shiny",
    trade_fodder: "Trade Fodder",
    trade_fodder_desc: "Low IV non-favorites for trading",
    recent_catches: "Recent Catches",
    recent_catches_desc: "Pokemon caught in the last week",
    evolution_ready: "Evolution Ready",
    evolution_ready_desc: "Can evolve, not favorited",
    shiny_costume: "Shiny Costume",
    shiny_costume_desc: "Shiny Pokemon with costumes",
    legendary_non_shiny: "Legendary Non-Shiny",
    legendary_non_shiny_desc: "Legendaries you haven't found shiny",
    pvp_league_cp_caps: "PvP League CP Caps",
    pvp_league_cp_caps_desc: "These are the competitive PvP league CP caps used in Pokemon GO. Clicking a button will insert or replace the CP range in your search string.",
    great_league: "Great League",
    great_league_cp: "CP 0-1500",
    ultra_league: "Ultra League",
    ultra_league_cp: "CP 0-2500",
    master_league: "Master League",
    master_league_cp: "CP 2500+",
    under_500_cp: "Under 500 CP",
    under_500_cp_value: "CP 0-500",
    high_cp: "High CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "Perfect CP",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "Raid tiers, PvP, and common combos",
    premade_pvp_competitive: "PvP & Competitive",
    premade_raid_attackers: "Raid Tier Attackers",
    premade_master_league: "Master League PvP",
    premade_common_combos: "Common Combos",
    info_shadow_vs_nonshadow_title: "Shadow vs Non-Shadow",
    info_shadow_vs_nonshadow_text: "Pokemon GO cannot display Shadow and non-Shadow versions simultaneously. Use separate searches.",
    info_master_league_title: "Master League Rankings",
    info_master_league_text: "Based on Master League PvP rankings for competitive battling. Includes top-ranked Pokemon like Zacian (Crowned Sword), Palkia (Origin & Shadow), Zamazenta (Crowned Shield), Dialga (Origin & Shadow), Kyurem (White & Black), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss, and Solgaleo.",
    tier_s_label: "S-Tier",
    tier_s_description: "Apex of Power",
    tier_aplus_label: "A+ Tier",
    tier_aplus_description: "Stand at or Near the Top",
    tier_a_label: "A Tier",
    tier_a_description: "Gold-Standard Investment",
    badge_shadow: "SHADOW",
    badge_mega: "MEGA",
    badge_mega_primal: "MEGA/PRIMAL",
    premade_s_tier_shadows: "S-Tier Shadows",
    premade_s_tier_shadows_desc: "Shadow Pokemon - apex of power",
    premade_s_tier_nonshadow: "S-Tier Non-Shadow",
    premade_s_tier_nonshadow_desc: "Mega/Primal Pokemon - top priorities",
    premade_aplus_tier_shadows: "A+ Tier Shadows",
    premade_aplus_tier_shadows_desc: "Shadow Pokemon - stand at or near the top",
    premade_aplus_tier_nonshadow: "A+ Tier Non-Shadow",
    premade_aplus_tier_nonshadow_desc: "Mega Pokemon - stand at or near the top",
    premade_a_tier_shadows: "A-Tier Shadows",
    premade_a_tier_shadows_desc: "Shadow Pokemon - gold-standard worthy of investment",
    premade_a_tier_nonshadow: "A-Tier Non-Shadow",
    premade_a_tier_nonshadow_desc: "Mega Pokemon - gold-standard worthy of investment",
    premade_top25_master_league: "Top 25 Master League",
    premade_top25_master_league_desc: "Top ranked Pokemon for Master League PvP competitive battling",
    premade_event_specific_searches: "⚡ Event-Specific Searches",
    premade_community_day_cleanup: "Community Day Cleanup",
    premade_community_day_cleanup_desc: "Shows recent catches (last 2 days) excluding shinies, good IVs, costumes, and favorites. Perfect for post-Community Day cleanup!",
    premade_spotlight_hour_2x_transfer: "Spotlight Hour 2x Transfer",
    premade_spotlight_hour_2x_transfer_desc: "Shows bad IV Legendaries/Mythicals to transfer during 2x candy Spotlight Hours (excludes shinies, hundos, and best buddies)",
    premade_frustration_tm_event: "Frustration TM Event",
    premade_frustration_tm_event_desc: "Shows Shadow Pokemon that still have the move Frustration (only removable during special Team Rocket events, ~4 times per year)",
    premade_counter_dragonite: "Counter Dragonite",
    premade_counter_dragonite_desc: "Type-based search to find strong counters to Dragonite",
    premade_counter_raid_boss_flying: "Counter Raid Boss (Flying)",
    premade_counter_raid_boss_flying_desc: "Strong attackers that hit Flying-type raid bosses super effectively",
    premade_tankiest_vs_fire: "Tankiest vs Fire",
    premade_tankiest_vs_fire_desc: "Bulky options that resist or neutralize Fire damage",
    premade_counter_meta_dragons: "Counter Meta Dragons",
    premade_counter_meta_dragons_desc: "Flexible counters to common Dragon-type threats",
    how_to_use_filter_buttons: "How to use the filter buttons",
    operator_and_title: "AND",
    operator_and_symbol: "&",
    operator_and_description: "Must have this filter - combines with other AND filters (Example: Shiny AND Legendary shows only shiny legendaries)",
    operator_or_title: "OR",
    operator_or_symbol: ",",
    operator_or_description: "Can have any of these - shows alternatives (Example: 4★ OR 3★ shows all 3-star and 4-star Pokémon)",
    operator_not_title: "NOT",
    operator_not_symbol: "!",
    operator_not_description: "Exclude this filter - hides matching Pokémon (Example: NOT Shadow excludes all shadow Pokémon)",
    operator_tip: "💡 Tip: You can combine operators! Try \"4★ AND Legendary OR Mythical AND NOT Shadow\" to find perfect IV legendaries/mythicals that aren't shadow.",
    type_effectiveness_help: "\">\" means your Pokémon deals super-effective damage TO that type. \"<\" means your Pokémon takes super-effective damage FROM that type. Examples: \">flying\" shows Pokémon that counter Flying (Electric, Rock, Ice). \"<flying\" shows Pokémon weak to Flying (Grass, Bug, Fighting). \">flying,>dragon\" counters Flying OR Dragon. \">flying&!<ice\" counters Flying AND is not weak to Ice.",
    validation_error_multiple_attack_ivs: "Cannot use AND with multiple Attack IVs ({filters})",
    validation_error_multiple_attack_ivs_why: "A Pokémon can only have ONE Attack IV value. You're asking for {filters} simultaneously.",
    validation_error_multiple_attack_ivs_fix: "Change to OR: {filters} - this will show Pokémon with ANY of these Attack values.",
    validation_error_multiple_defense_ivs: "Cannot use AND with multiple Defense IVs ({filters})",
    validation_error_multiple_defense_ivs_why: "A Pokémon can only have ONE Defense IV value. You're asking for {filters} simultaneously.",
    validation_error_multiple_defense_ivs_fix: "Change to OR: {filters} - this will show Pokémon with ANY of these Defense values.",
    validation_error_multiple_hp_ivs: "Cannot use AND with multiple HP IVs ({filters})",
    validation_error_multiple_hp_ivs_why: "A Pokémon can only have ONE HP IV value. You're asking for {filters} simultaneously.",
    validation_error_multiple_hp_ivs_fix: "Change to OR: {filters} - this will show Pokémon with ANY of these HP values.",
    validation_error_multiple_star_ratings: "Cannot use AND with multiple star ratings ({filters})",
    validation_error_multiple_star_ratings_why: "A Pokémon has ONE star rating based on total IVs. It cannot be {filters} simultaneously.",
    validation_error_multiple_star_ratings_fix: "Change to OR: {filters} - this will show Pokémon with ANY of these star ratings.",
    validation_error_shadow_and_purified: "Shadow AND Purified",
    validation_error_shadow_and_purified_why: "A Pokémon cannot be both Shadow AND Purified. Once purified, it's no longer shadow.",
    validation_error_shadow_and_purified_fix: "Change to OR: shadow,purified - this will show Pokémon that are EITHER shadow OR purified.",
    validation_error_4star_with_nonperfect: "4★ with non-perfect IVs ({filters})",
    validation_error_4star_with_nonperfect_why: "4★ means 15/15/15 (all perfect stats). Cannot have {nonperfect} when requiring perfect stats.",
    validation_error_4star_with_nonperfect_fix: "Remove 4★, or remove {filters}, or change 4★ to OR if you want either perfect OR non-perfect.",
    validation_error_perfect_stats_exclude_4star: "Requiring perfect Attack, Defense, and HP but excluding 4★",
    validation_error_perfect_stats_exclude_4star_why: "15/15/15 IS a 4★ (perfect) Pokémon. You cannot have all perfect stats and NOT be 4★.",
    validation_error_perfect_stats_exclude_4star_fix: "Remove NOT 4★, or remove one of the perfect stat requirements.",
    validation_error_0star_with_high_ivs: "0★ with high IVs ({filters})",
    validation_error_0star_with_high_ivs_why: "0★ means 0-49% total IVs (0-22 stat points). High IVs like {filters} would push it above 0★.",
    validation_error_0star_with_high_ivs_fix: "Change 0★ to a higher star rating, or remove the high IV filters, or use OR instead of AND.",
    validation_error_3star_with_zero_ivs: "3★ with {count} zero IVs ({filters})",
    validation_error_3star_with_zero_ivs_why: "3★ requires 37-44 total stat points (82-98%). Having 2+ stats at 0 makes this mathematically impossible.",
    validation_error_3star_with_zero_ivs_fix: "Remove 3★, or remove the zero IV filters, or change to 1★ or 0★.",
    validation_error_2star_with_zero_ivs: "2★ with 2+ zero IVs ({filters})",
    validation_error_2star_with_zero_ivs_why: "2★ requires 30-36 total stat points. With 2 stats at 0, you'd need the third at 30+ which is impossible (max is 15).",
    validation_error_2star_with_zero_ivs_fix: "Remove 2★, or remove the zero IV filters, or change to 0★ or 1★.",
    validation_error_3star_with_all_perfect: "3★ with all perfect IVs (4attack, 4defense, 4hp)",
    validation_error_3star_with_all_perfect_why: "3★ means 82-98% total IVs (37-44 stat points). Three perfect stats = 45 points, which is 4★ (100%), not 3★.",
    validation_error_3star_with_all_perfect_fix: "Change 3★ to 4★, or remove one of the perfect IV requirements."
  },
  "Spanish": {
    app_title: "Constructor de Búsqueda Pokémon GO",
    app_subtitle: "Crea cadenas de búsqueda visualmente",
    search_string: "Cadena de Búsqueda",
    search_placeholder: "Tu cadena de búsqueda aparecerá aquí...",
    filter_search_placeholder: "Buscar filtros... (ej., 'shiny')",
    stats_ivs: "Estadísticas e IVs",
    types: "Tipos",
    type_effectiveness: "Efectividad de Tipo",
    special_status: "Estado Especial",
    evolution_buddy: "Evolución y Compañero",
    time_distance: "Tiempo y Distancia",
    size_gender: "Tamaño y Género",
    moves: "Movimientos",
    regions: "Regiones",
    clear_all: "Limpiar Todo",
    copy: "Copiar",
    copied: "¡Copiado!",
    copy_has_issues: "Copiar (Tiene problemas)",
    validation_error_title: "⚠️ Esta búsqueda no funcionará en Pokémon GO",
    validation_error_subtitle: "Estas combinaciones son imposibles, pero aún puedes copiar si quieres experimentar.",
    validation_why_label: "Por qué no funcionará:",
    validation_fix_label: "✓ Cómo arreglarlo:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "Ataque Perfecto (15)",
    filter_3attack: "Ataque Alto (12-14)",
    filter_4defense: "Defensa Perfecta (15)",
    filter_3defense: "Defensa Alta (12-14)",
    filter_4hp: "PS Perfectos (15)",
    filter_3hp: "PS Altos (12-14)",
    filter_0attack: "Ataque Cero",
    filter_0defense: "Defensa Cero",
    filter_0hp: "PS Cero",
    filter_shiny: "Brillante",
    filter_lucky: "Afortunado",
    filter_shadow: "Sombra",
    filter_purified: "Purificado",
    filter_legendary: "Legendario",
    filter_mythical: "Mítico",
    save_this_search: "Guardar esta búsqueda",
    search_saved: "¡Búsqueda guardada!",
    active: "activo",
    light_mode: "Modo claro",
    dark_mode: "Modo oscuro",
    translation_warnings: "Advertencias de Traducción:",
    conflicting_filters: "Filtros en Conflicto",
    remove_spaces: "Eliminar espacios de la cadena de búsqueda",
    missing_ampersand: "Falta & entre filtros",
    use_commas: "Usa comas entre números de Pokédex, no &",
    quick_searches: "Búsquedas Rápidas",
    cp_ranges: "Rangos de PC",
    pokemon_selection: "Selección de Pokémon",
    pokemon_groups: "Grupos de Pokémon",
    insert_cp_range: "Insertar rangos de PC para ligas PvP",
    quick_insert_pokemon: "Inserción rápida de rangos y grupos de Pokémon",
    saved_searches: "Búsquedas Guardadas",
    import_searches: "Importar búsquedas",
    export_searches: "Exportar búsquedas",
    delete_saved_search: "Eliminar búsqueda guardada",
    storage_limit_reached: "Límite de almacenamiento alcanzado. Por favor elimina algunas búsquedas guardadas.",
    failed_import: "Error al importar búsquedas guardadas. Por favor verifica el formato del archivo.",
    language: "Idioma",
    language_wip: "(WIP)",
    join_discord: "Únete al Discord para actualizaciones, sugerencias y reportes de errores",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Capturado Hoy",
    last_7_days: "Últimos 7 Días",
    last_30_days: "Últimos 30 Días",
    last_week: "Última Semana",
    last_month: "Último Mes",
    last_year: "Último Año",
    custom_age: "Rango de Fecha Personalizado",
    today: "Hoy",
    more_than_days_ago: "Hace más de {days} días",
    days_ago: "Hace {start}-{end} días",
    last_days: "Últimos {days} días",
    age_label: "Edad {value}",
    distance_1000km_plus: "Distancia 1000km+",
    distance_100km_plus: "Distancia 100km+",
    include: "Incluir",
    exclude: "Excluir",
    custom_date_range: "Rango de Fecha Personalizado",
    examples: "Ejemplos",
    invalid_format: "Formato inválido. Use: número (ej., 30), rango (ej., 0-7), o formato edad (ej., age0-30)",
    generations: "Generaciones",
    pokemon_groups: "Grupos de Pokémon",
    gen_1_kanto: "Gen 1 (Kanto)",
    gen_2_johto: "Gen 2 (Johto)",
    gen_3_hoenn: "Gen 3 (Hoenn)",
    gen_4_sinnoh: "Gen 4 (Sinnoh)",
    gen_5_unova: "Gen 5 (Unova)",
    gen_6_kalos: "Gen 6 (Kalos)",
    gen_7_alola: "Gen 7 (Alola)",
    gen_8_galar: "Gen 8 (Galar)",
    all_starters: "Todos los Iniciales",
    kanto_starters: "Iniciales de Kanto",
    johto_starters: "Iniciales de Johto",
    hoenn_starters: "Iniciales de Hoenn",
    sinnoh_starters: "Iniciales de Sinnoh",
    unova_starters: "Iniciales de Unova",
    kalos_starters: "Iniciales de Kalos",
    alola_starters: "Iniciales de Alola",
    galar_starters: "Iniciales de Galar",
    pseudo_legendaries: "Pseudo-Legendarios",
    eeveelutions: "Eeveeluciones",
    quick_combos: "Combos Rápidos",
    quick_combos_info: "Estos botones agregan combinaciones de filtros a tu cadena de búsqueda existente, permitiéndote apilar múltiples combos juntos.",
    shiny_legendaries: "Legendarios Brillantes",
    shiny_legendaries_desc: "Todos los Pokémon legendarios brillantes",
    perfect_shadows: "Sombras Perfectas",
    perfect_shadows_desc: "Pokémon sombra con 100% IV",
    high_iv_non_shiny: "Alto IV No Brillante",
    high_iv_non_shiny_desc: "Pokémon 3-4★ que no son brillantes",
    trade_fodder: "Material de Intercambio",
    trade_fodder_desc: "Bajo IV no favoritos para intercambiar",
    recent_catches: "Capturas Recientes",
    recent_catches_desc: "Pokémon capturados en la última semana",
    evolution_ready: "Listo para Evolucionar",
    evolution_ready_desc: "Puede evolucionar, no favorito",
    shiny_costume: "Disfraz Brillante",
    shiny_costume_desc: "Pokémon brillantes con disfraces",
    legendary_non_shiny: "Legendario No Brillante",
    legendary_non_shiny_desc: "Legendarios que no has encontrado brillantes",
    pvp_league_cp_caps: "Límites de CP de Liga PvP",
    pvp_league_cp_caps_desc: "Estos son los límites de CP competitivos de las ligas PvP usados en Pokémon GO. Al hacer clic en un botón se insertará o reemplazará el rango de CP en tu cadena de búsqueda.",
    great_league: "Liga Principal",
    great_league_cp: "CP 0-1500",
    ultra_league: "Liga Ultra",
    ultra_league_cp: "CP 0-2500",
    master_league: "Liga Maestra",
    master_league_cp: "CP 2500+",
    under_500_cp: "Menos de 500 CP",
    under_500_cp_value: "CP 0-500",
    high_cp: "Alto CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "CP Perfecto",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "Niveles de incursión, PvP y combinaciones comunes",
    premade_pvp_competitive: "PvP y Competitivo",
    premade_raid_attackers: "Atacantes de Nivel de Incursión",
    premade_master_league: "PvP Liga Maestra",
    premade_common_combos: "Combinaciones Comunes",
    info_shadow_vs_nonshadow_title: "Shadow vs No-Shadow",
    info_shadow_vs_nonshadow_text: "Pokémon GO no puede mostrar versiones Shadow y no-Shadow simultáneamente. Usa búsquedas separadas.",
    info_master_league_title: "Clasificaciones de Liga Maestra",
    info_master_league_text: "Basado en las clasificaciones de PvP de Liga Maestra para combates competitivos. Incluye Pokémon mejor clasificados como Zacian (Espada Coronada), Palkia (Origen y Shadow), Zamazenta (Escudo Coronado), Dialga (Origen y Shadow), Kyurem (Blanco y Negro), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss y Solgaleo.",
    tier_s_label: "Nivel S",
    tier_s_description: "Cúspide del Poder",
    tier_aplus_label: "Nivel A+",
    tier_aplus_description: "Se Mantienen en o Cerca de la Cima",
    tier_a_label: "Nivel A",
    tier_a_description: "Inversión Estándar de Oro",
    badge_shadow: "SOMBRA",
    badge_mega: "MEGA",
    badge_mega_primal: "MEGA/PRIMIGENIO",
    premade_s_tier_shadows: "Sombras Nivel S",
    premade_s_tier_shadows_desc: "Pokémon Shadow - cúspide del poder",
    premade_s_tier_nonshadow: "No-Shadow Nivel S",
    premade_s_tier_nonshadow_desc: "Pokémon Mega/Primal - máximas prioridades",
    premade_aplus_tier_shadows: "Sombras Nivel A+",
    premade_aplus_tier_shadows_desc: "Pokémon Shadow - se mantienen en o cerca de la cima",
    premade_aplus_tier_nonshadow: "No-Shadow Nivel A+",
    premade_aplus_tier_nonshadow_desc: "Pokémon Mega - se mantienen en o cerca de la cima",
    premade_a_tier_shadows: "Sombras Nivel A",
    premade_a_tier_shadows_desc: "Pokémon Shadow - estándar de oro digno de inversión",
    premade_a_tier_nonshadow: "No-Shadow Nivel A",
    premade_a_tier_nonshadow_desc: "Pokémon Mega - estándar de oro digno de inversión",
    premade_top25_master_league: "Top 25 Liga Maestra",
    premade_top25_master_league_desc: "Pokémon mejor clasificados para combates competitivos de PvP Liga Maestra",
    premade_counter_dragonite: "Contra Dragonite",
    premade_counter_dragonite_desc: "Búsqueda por tipos para encontrar buenos contraataques a Dragonite",
    premade_counter_raid_boss_flying: "Contra Jefe de Incursión (Volador)",
    premade_counter_raid_boss_flying_desc: "Atacantes fuertes que golpean súper eficaz a jefes de incursión de tipo Volador",
    premade_tankiest_vs_fire: "Más resistentes vs Fuego",
    premade_tankiest_vs_fire_desc: "Opciones robustas que resisten o neutralizan el daño de Fuego",
    premade_counter_meta_dragons: "Contra Dragones Meta",
    premade_counter_meta_dragons_desc: "Contraataques flexibles contra amenazas comunes de tipo Dragón"
  },
  "Brazilian Portuguese": {
    app_title: "Construtor de Busca Pokémon GO",
    app_subtitle: "Crie strings de busca visualmente",
    search_string: "String de Busca",
    search_placeholder: "Sua string de busca aparecerá aqui...",
    filter_search_placeholder: "Buscar filtros... (ex., 'shiny')",
    stats_ivs: "Estatísticas e IVs",
    types: "Tipos",
    special_status: "Status Especial",
    evolution_buddy: "Evolução e Companheiro",
    time_distance: "Tempo e Distância",
    size_gender: "Tamanho e Gênero",
    moves: "Movimentos",
    regions: "Regiões",
    clear_all: "Limpar Tudo",
    copy: "Copiar",
    copied: "Copiado!",
    copy_has_issues: "Copiar (Tem problemas)",
    validation_error_title: "⚠️ Esta busca não funcionará no Pokémon GO",
    validation_error_subtitle: "Essas combinações são impossíveis, mas você ainda pode copiar se quiser experimentar.",
    validation_why_label: "Por que não funcionará:",
    validation_fix_label: "✓ Como corrigir:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "Ataque Perfeito (15)",
    filter_3attack: "Ataque Alto (12-14)",
    filter_4defense: "Defesa Perfeita (15)",
    filter_3defense: "Defesa Alta (12-14)",
    filter_4hp: "PS Perfeitos (15)",
    filter_3hp: "PS Altos (12-14)",
    filter_0attack: "Ataque Zero",
    filter_0defense: "Defesa Zero",
    filter_0hp: "PS Zero",
    filter_shiny: "Brilhante",
    filter_lucky: "Sortudo",
    filter_shadow: "Sombrio",
    filter_purified: "Purificado",
    filter_legendary: "Lendário",
    filter_mythical: "Mítico",
    save_this_search: "Salvar esta busca",
    search_saved: "Busca salva!",
    active: "ativo",
    light_mode: "Modo claro",
    dark_mode: "Modo escuro",
    translation_warnings: "Avisos de Tradução:",
    conflicting_filters: "Filtros Conflitantes",
    remove_spaces: "Remover espaços da string de busca",
    missing_ampersand: "Falta & entre filtros",
    use_commas: "Use vírgulas entre números de Pokédex, não &",
    quick_searches: "Buscas Rápidas",
    cp_ranges: "Faixas de PC",
    pokemon_selection: "Seleção de Pokémon",
    pokemon_groups: "Grupos de Pokémon",
    insert_cp_range: "Inserir faixas de PC para ligas PvP",
    quick_insert_pokemon: "Inserção rápida de faixas e grupos de Pokémon",
    saved_searches: "Buscas Salvas",
    import_searches: "Importar buscas",
    export_searches: "Exportar buscas",
    delete_saved_search: "Excluir busca salva",
    storage_limit_reached: "Limite de armazenamento atingido. Por favor, exclua algumas buscas salvas.",
    failed_import: "Falha ao importar buscas salvas. Por favor, verifique o formato do arquivo.",
    language: "Idioma",
    language_wip: "(WIP)",
    join_discord: "Junte-se ao Discord para atualizações, sugestões e relatórios de bugs",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Capturado Hoje",
    last_7_days: "Últimos 7 Dias",
    last_30_days: "Últimos 30 Dias",
    last_week: "Última Semana",
    last_month: "Último Mês",
    last_year: "Último Ano",
    custom_age: "Idade Personalizada",
    today: "Hoje",
    more_than_days_ago: "Há mais de {days} dias",
    days_ago: "Há {start}-{end} dias",
    last_days: "Últimos {days} dias",
    age_label: "Idade {value}",
    distance_1000km_plus: "Distância 1000km+",
    distance_100km_plus: "Distância 100km+",
    include: "Incluir",
    exclude: "Excluir",
    custom_date_range: "Intervalo de Data Personalizado",
    examples: "Exemplos",
    invalid_format: "Formato inválido. Use: número (ex., 30), intervalo (ex., 0-7), ou formato idade (ex., age0-30)",
    generations: "Gerações",
    pokemon_groups: "Grupos de Pokémon",
    gen_1_kanto: "Gen 1 (Kanto)",
    gen_2_johto: "Gen 2 (Johto)",
    gen_3_hoenn: "Gen 3 (Hoenn)",
    gen_4_sinnoh: "Gen 4 (Sinnoh)",
    gen_5_unova: "Gen 5 (Unova)",
    gen_6_kalos: "Gen 6 (Kalos)",
    gen_7_alola: "Gen 7 (Alola)",
    gen_8_galar: "Gen 8 (Galar)",
    all_starters: "Todos os Iniciais",
    kanto_starters: "Iniciais de Kanto",
    johto_starters: "Iniciais de Johto",
    hoenn_starters: "Iniciais de Hoenn",
    sinnoh_starters: "Iniciais de Sinnoh",
    unova_starters: "Iniciais de Unova",
    kalos_starters: "Iniciais de Kalos",
    alola_starters: "Iniciais de Alola",
    galar_starters: "Iniciais de Galar",
    pseudo_legendaries: "Pseudo-Lendários",
    eeveelutions: "Eeveeluições",
    quick_combos: "Combos Rápidos",
    quick_combos_info: "Estes botões adicionam combinações de filtros à sua string de busca existente, permitindo que você empilhe múltiplos combos juntos.",
    shiny_legendaries: "Lendários Brilhantes",
    shiny_legendaries_desc: "Todos os Pokémon lendários brilhantes",
    perfect_shadows: "Sombras Perfeitas",
    perfect_shadows_desc: "Pokémon sombra com 100% de IV",
    high_iv_non_shiny: "Alto IV Não Brilhante",
    high_iv_non_shiny_desc: "Pokémon 3-4★ que não são brilhantes",
    trade_fodder: "Material de Troca",
    trade_fodder_desc: "Baixo IV não favoritos para trocar",
    recent_catches: "Capturas Recentes",
    recent_catches_desc: "Pokémon capturados na última semana",
    evolution_ready: "Pronto para Evoluir",
    evolution_ready_desc: "Pode evoluir, não favorito",
    shiny_costume: "Fantasia Brilhante",
    shiny_costume_desc: "Pokémon brilhantes com fantasias",
    legendary_non_shiny: "Lendário Não Brilhante",
    legendary_non_shiny_desc: "Lendários que você não encontrou brilhantes",
    pvp_league_cp_caps: "Limites de CP das Ligas PvP",
    pvp_league_cp_caps_desc: "Estes são os limites de CP competitivos das ligas PvP usados em Pokémon GO. Clicar em um botão irá inserir ou substituir o intervalo de CP em sua string de busca.",
    great_league: "Liga Principal",
    great_league_cp: "CP 0-1500",
    ultra_league: "Liga Ultra",
    ultra_league_cp: "CP 0-2500",
    master_league: "Liga Mestra",
    master_league_cp: "CP 2500+",
    under_500_cp: "Menos de 500 CP",
    under_500_cp_value: "CP 0-500",
    high_cp: "Alto CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "CP Perfeito",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "Níveis de incursão, PvP e combinações comuns",
    premade_pvp_competitive: "PvP e Competitivo",
    premade_raid_attackers: "Atacantes de Nível de Incursão",
    premade_master_league: "PvP Liga Mestra",
    premade_common_combos: "Combinações Comuns",
    info_shadow_vs_nonshadow_title: "Shadow vs Não-Shadow",
    info_shadow_vs_nonshadow_text: "Pokémon GO não pode exibir versões Shadow e não-Shadow simultaneamente. Use buscas separadas.",
    info_master_league_title: "Classificações da Liga Mestra",
    info_master_league_text: "Baseado nas classificações de PvP da Liga Mestra para batalhas competitivas. Inclui Pokémon melhor classificados como Zacian (Espada Coroada), Palkia (Origem e Shadow), Zamazenta (Escudo Coroado), Dialga (Origem e Shadow), Kyurem (Branco e Preto), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss e Solgaleo.",
    tier_s_label: "Nível S",
    tier_s_description: "Ápice do Poder",
    tier_aplus_label: "Nível A+",
    tier_aplus_description: "Ficam no ou Perto do Topo",
    tier_a_label: "Nível A",
    tier_a_description: "Investimento Padrão Ouro",
    badge_shadow: "OBSCURO",
    badge_mega: "MEGA",
    badge_mega_primal: "MEGA/PRIMORDIAL",
    premade_s_tier_shadows: "Sombras Nível S",
    premade_s_tier_shadows_desc: "Pokémon Shadow - ápice do poder",
    premade_s_tier_nonshadow: "Não-Shadow Nível S",
    premade_s_tier_nonshadow_desc: "Pokémon Mega/Primal - máximas prioridades",
    premade_aplus_tier_shadows: "Sombras Nível A+",
    premade_aplus_tier_shadows_desc: "Pokémon Shadow - ficam no ou perto do topo",
    premade_aplus_tier_nonshadow: "Não-Shadow Nível A+",
    premade_aplus_tier_nonshadow_desc: "Pokémon Mega - ficam no ou perto do topo",
    premade_a_tier_shadows: "Sombras Nível A",
    premade_a_tier_shadows_desc: "Pokémon Shadow - padrão ouro digno de investimento",
    premade_a_tier_nonshadow: "Não-Shadow Nível A",
    premade_a_tier_nonshadow_desc: "Pokémon Mega - padrão ouro digno de investimento",
    premade_top25_master_league: "Top 25 Liga Mestra",
    premade_top25_master_league_desc: "Pokémon melhor classificados para batalhas competitivas de PvP Liga Mestra",
    premade_counter_dragonite: "Counter Dragonite",
    premade_counter_dragonite_desc: "Busca baseada em tipos para encontrar fortes contra-ataques ao Dragonite",
    premade_counter_raid_boss_flying: "Counter Chefe de Raid (Voador)",
    premade_counter_raid_boss_flying_desc: "Atacantes fortes que acertam chefes de raid do tipo Voador de forma super eficaz",
    premade_tankiest_vs_fire: "Tankiest vs Fogo",
    premade_tankiest_vs_fire_desc: "Opções robustas que resistem ou neutralizam o dano de Fogo",
    premade_counter_meta_dragons: "Counter Dragões Meta",
    premade_counter_meta_dragons_desc: "Contra-ataques flexíveis contra ameaças comuns do tipo Dragão"
  },
  "French": {
    app_title: "Constructeur de Recherche Pokémon GO",
    app_subtitle: "Créez des chaînes de recherche visuellement",
    search_string: "Chaîne de Recherche",
    search_placeholder: "Votre chaîne de recherche apparaîtra ici...",
    filter_search_placeholder: "Rechercher des filtres... (ex., 'shiny')",
    stats_ivs: "Statistiques et IVs",
    types: "Types",
    type_effectiveness: "Efficacité des Types",
    special_status: "Statut Spécial",
    evolution_buddy: "Évolution et Compagnon",
    time_distance: "Temps et Distance",
    size_gender: "Taille et Sexe",
    moves: "Capacités",
    regions: "Régions",
    clear_all: "Tout Effacer",
    copy: "Copier",
    copied: "Copié !",
    copy_has_issues: "Copier (A des problèmes)",
    validation_error_title: "⚠️ Cette recherche ne fonctionnera pas dans Pokémon GO",
    validation_error_subtitle: "Ces combinaisons sont impossibles, mais vous pouvez toujours copier si vous voulez expérimenter.",
    validation_why_label: "Pourquoi ça ne marchera pas:",
    validation_fix_label: "✓ Comment corriger:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "Attaque Parfaite (15)",
    filter_3attack: "Attaque Élevée (12-14)",
    filter_4defense: "Défense Parfaite (15)",
    filter_3defense: "Défense Élevée (12-14)",
    filter_4hp: "PV Parfaits (15)",
    filter_3hp: "PV Élevés (12-14)",
    filter_0attack: "Attaque Zéro",
    filter_0defense: "Défense Zéro",
    filter_0hp: "PV Zéro",
    filter_shiny: "Chromatique",
    filter_lucky: "Chanceux",
    filter_shadow: "Obscur",
    filter_purified: "Purifié",
    filter_legendary: "Légendaire",
    filter_mythical: "Fabuleux",
    save_this_search: "Enregistrer cette recherche",
    search_saved: "Recherche enregistrée !",
    active: "actif",
    light_mode: "Mode clair",
    dark_mode: "Mode sombre",
    translation_warnings: "Avertissements de Traduction :",
    conflicting_filters: "Filtres en Conflit",
    remove_spaces: "Supprimer les espaces de la chaîne de recherche",
    missing_ampersand: "& manquant entre les filtres",
    use_commas: "Utilisez des virgules entre les numéros de Pokédex, pas &",
    quick_searches: "Recherches Rapides",
    cp_ranges: "Plages de PC",
    pokemon_selection: "Sélection de Pokémon",
    pokemon_groups: "Groupes de Pokémon",
    insert_cp_range: "Insérer des plages de PC pour les ligues PvP",
    quick_insert_pokemon: "Insertion rapide de plages et groupes de Pokémon",
    saved_searches: "Recherches Enregistrées",
    import_searches: "Importer des recherches",
    export_searches: "Exporter des recherches",
    delete_saved_search: "Supprimer la recherche enregistrée",
    storage_limit_reached: "Limite de stockage atteinte. Veuillez supprimer certaines recherches enregistrées.",
    failed_import: "Échec de l'importation des recherches enregistrées. Veuillez vérifier le format du fichier.",
    language: "Langue",
    language_wip: "(WIP)",
    join_discord: "Rejoignez le Discord pour les mises à jour, suggestions et rapports de bugs",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Attrapé Aujourd'hui",
    last_7_days: "7 Derniers Jours",
    last_30_days: "30 Derniers Jours",
    last_week: "Dernière Semaine",
    last_month: "Dernier Mois",
    last_year: "Dernière Année",
    custom_age: "Âge Personnalisé",
    today: "Aujourd'hui",
    more_than_days_ago: "Il y a plus de {days} jours",
    days_ago: "Il y a {start}-{end} jours",
    last_days: "Derniers {days} jours",
    age_label: "Âge {value}",
    distance_1000km_plus: "Distance 1000km+",
    distance_100km_plus: "Distance 100km+",
    include: "Inclure",
    exclude: "Exclure",
    custom_date_range: "Plage de Dates Personnalisée",
    examples: "Exemples",
    invalid_format: "Format invalide. Utilisez: nombre (ex., 30), plage (ex., 0-7), ou format âge (ex., age0-30)",
    generations: "Générations",
    pokemon_groups: "Groupes de Pokémon",
    gen_1_kanto: "Gén 1 (Kanto)",
    gen_2_johto: "Gén 2 (Johto)",
    gen_3_hoenn: "Gén 3 (Hoenn)",
    gen_4_sinnoh: "Gén 4 (Sinnoh)",
    gen_5_unova: "Gén 5 (Unova)",
    gen_6_kalos: "Gén 6 (Kalos)",
    gen_7_alola: "Gén 7 (Alola)",
    gen_8_galar: "Gén 8 (Galar)",
    all_starters: "Tous les Starters",
    kanto_starters: "Starters de Kanto",
    johto_starters: "Starters de Johto",
    hoenn_starters: "Starters de Hoenn",
    sinnoh_starters: "Starters de Sinnoh",
    unova_starters: "Starters d'Unova",
    kalos_starters: "Starters de Kalos",
    alola_starters: "Starters d'Alola",
    galar_starters: "Starters de Galar",
    pseudo_legendaries: "Pseudo-Légendaires",
    eeveelutions: "Évolitions d'Évoli",
    quick_combos: "Combos Rapides",
    quick_combos_info: "Ces boutons ajoutent des combinaisons de filtres à votre chaîne de recherche existante, vous permettant d'empiler plusieurs combos ensemble.",
    shiny_legendaries: "Légendaires Chromatiques",
    shiny_legendaries_desc: "Tous les Pokémon légendaires chromatiques",
    perfect_shadows: "Ombres Parfaites",
    perfect_shadows_desc: "Pokémon ombre avec 100% d'IV",
    high_iv_non_shiny: "Haut IV Non Chromatique",
    high_iv_non_shiny_desc: "Pokémon 3-4★ qui ne sont pas chromatiques",
    trade_fodder: "Matériel d'Échange",
    trade_fodder_desc: "Faible IV non favoris pour échanger",
    recent_catches: "Captures Récentes",
    recent_catches_desc: "Pokémon capturés la semaine dernière",
    evolution_ready: "Prêt à Évoluer",
    evolution_ready_desc: "Peut évoluer, pas favori",
    shiny_costume: "Déguisement Chromatique",
    shiny_costume_desc: "Pokémon chromatiques avec déguisements",
    legendary_non_shiny: "Légendaire Non Chromatique",
    legendary_non_shiny_desc: "Légendaires que vous n'avez pas trouvés chromatiques",
    pvp_league_cp_caps: "Plafonds de CP des Ligues PvP",
    pvp_league_cp_caps_desc: "Ce sont les plafonds de CP compétitifs des ligues PvP utilisés dans Pokémon GO. Cliquer sur un bouton insérera ou remplacera la plage de CP dans votre chaîne de recherche.",
    great_league: "Ligue Super",
    great_league_cp: "CP 0-1500",
    ultra_league: "Ligue Hyper",
    ultra_league_cp: "CP 0-2500",
    master_league: "Ligue Master",
    master_league_cp: "CP 2500+",
    under_500_cp: "Moins de 500 CP",
    under_500_cp_value: "CP 0-500",
    high_cp: "Haut CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "CP Parfait",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "Niveaux de raid, PvP et combos courants",
    premade_pvp_competitive: "PvP et Compétitif",
    premade_raid_attackers: "Attaquants de Niveau de Raid",
    premade_master_league: "PvP Ligue Master",
    premade_common_combos: "Combos Courants",
    info_shadow_vs_nonshadow_title: "Shadow vs Non-Shadow",
    info_shadow_vs_nonshadow_text: "Pokémon GO ne peut pas afficher les versions Shadow et non-Shadow simultanément. Utilisez des recherches séparées.",
    info_master_league_title: "Classements de la Ligue Master",
    info_master_league_text: "Basé sur les classements PvP de la Ligue Master pour les combats compétitifs. Inclut les Pokémon les mieux classés comme Zacian (Épée Couronnée), Palkia (Origine et Shadow), Zamazenta (Bouclier Couronné), Dialga (Origine et Shadow), Kyurem (Blanc et Noir), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss et Solgaleo.",
    tier_s_label: "Niveau S",
    tier_s_description: "Sommet du Pouvoir",
    tier_aplus_label: "Niveau A+",
    tier_aplus_description: "Se Tiennent au ou Près du Sommet",
    tier_a_label: "Niveau A",
    tier_a_description: "Investissement Standard Or",
    badge_shadow: "OBSCUR",
    badge_mega: "MÉGA",
    badge_mega_primal: "MÉGA/PRIMO",
    premade_s_tier_shadows: "Ombres Niveau S",
    premade_s_tier_shadows_desc: "Pokémon Ombres - sommet du pouvoir",
    premade_s_tier_nonshadow: "Non-Ombres Niveau S",
    premade_s_tier_nonshadow_desc: "Pokémon Méga/Primal - priorités maximales",
    premade_aplus_tier_shadows: "Ombres Niveau A+",
    premade_aplus_tier_shadows_desc: "Pokémon Ombres - se tiennent au ou près du sommet",
    premade_aplus_tier_nonshadow: "Non-Ombres Niveau A+",
    premade_aplus_tier_nonshadow_desc: "Pokémon Méga - se tiennent au ou près du sommet",
    premade_a_tier_shadows: "Ombres Niveau A",
    premade_a_tier_shadows_desc: "Pokémon Ombres - standard or digne d'investissement",
    premade_a_tier_nonshadow: "Non-Ombres Niveau A",
    premade_a_tier_nonshadow_desc: "Pokémon Méga - standard or digne d'investissement",
    premade_top25_master_league: "Top 25 Ligue Master",
    premade_top25_master_league_desc: "Pokémon les mieux classés pour les combats compétitifs PvP Ligue Master",
    premade_counter_dragonite: "Contrer Dracolosse",
    premade_counter_dragonite_desc: "Recherche basée sur les types pour trouver de bons contres à Dracolosse",
    premade_counter_raid_boss_flying: "Contrer Boss de Raid (Vol)",
    premade_counter_raid_boss_flying_desc: "Attaquants puissants qui frappent les boss de raid de type Vol de façon super efficace",
    premade_tankiest_vs_fire: "Plus tanky vs Feu",
    premade_tankiest_vs_fire_desc: "Options robustes qui résistent ou neutralisent les dégâts de type Feu",
    premade_counter_meta_dragons: "Contrer les Dragons Meta",
    premade_counter_meta_dragons_desc: "Contres flexibles aux menaces fréquentes de type Dragon"
  },
  "German": {
    app_title: "Pokémon GO Suchstring-Builder",
    app_subtitle: "Erstelle Suchstrings visuell",
    search_string: "Suchstring",
    search_placeholder: "Ihr Suchstring erscheint hier...",
    filter_search_placeholder: "Filter suchen... (z.B. 'shiny')",
    stats_ivs: "Werte & IVs",
    types: "Typen",
    type_effectiveness: "Typen-Effektivität",
    special_status: "Besonderer Status",
    evolution_buddy: "Entwicklung & Partner",
    time_distance: "Zeit & Entfernung",
    size_gender: "Größe & Geschlecht",
    moves: "Attacken",
    regions: "Regionen",
    clear_all: "Alles Löschen",
    copy: "Kopieren",
    copied: "Kopiert!",
    copy_has_issues: "Kopieren (Hat Probleme)",
    validation_error_title: "⚠️ Diese Suche funktioniert nicht in Pokémon GO",
    validation_error_subtitle: "Diese Kombinationen sind unmöglich, aber Sie können trotzdem kopieren, wenn Sie experimentieren möchten.",
    validation_why_label: "Warum es nicht funktioniert:",
    validation_fix_label: "✓ So beheben Sie es:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "Perfekter Angriff (15)",
    filter_3attack: "Hoher Angriff (12-14)",
    filter_4defense: "Perfekte Verteidigung (15)",
    filter_3defense: "Hohe Verteidigung (12-14)",
    filter_4hp: "Perfekte KP (15)",
    filter_3hp: "Hohe KP (12-14)",
    filter_0attack: "Null Angriff",
    filter_0defense: "Null Verteidigung",
    filter_0hp: "Null KP",
    filter_shiny: "Schillernd",
    filter_lucky: "Glückspilz",
    filter_shadow: "Schatten",
    filter_purified: "Gereinigt",
    filter_legendary: "Legendär",
    filter_mythical: "Mystisch",
    save_this_search: "Diese Suche speichern",
    search_saved: "Suche gespeichert!",
    active: "aktiv",
    light_mode: "Heller Modus",
    dark_mode: "Dunkler Modus",
    translation_warnings: "Übersetzungswarnungen:",
    conflicting_filters: "Widersprüchliche Filter",
    remove_spaces: "Leerzeichen aus Suchstring entfernen",
    missing_ampersand: "& fehlt zwischen Filtern",
    use_commas: "Verwenden Sie Kommas zwischen Pokédex-Nummern, nicht &",
    quick_searches: "Schnellsuchen",
    cp_ranges: "WP-Bereiche",
    pokemon_selection: "Pokémon-Auswahl",
    pokemon_groups: "Pokémon-Gruppen",
    insert_cp_range: "WP-Bereiche für PvP-Ligen einfügen",
    quick_insert_pokemon: "Schnelles Einfügen von Pokémon-Bereichen und -Gruppen",
    saved_searches: "Gespeicherte Suchen",
    import_searches: "Suchen importieren",
    export_searches: "Suchen exportieren",
    delete_saved_search: "Gespeicherte Suche löschen",
    storage_limit_reached: "Speicherlimit erreicht. Bitte löschen Sie einige gespeicherte Suchen.",
    failed_import: "Import gespeicherter Suchen fehlgeschlagen. Bitte überprüfen Sie das Dateiformat.",
    language: "Sprache",
    language_wip: "(WIP)",
    join_discord: "Treten Sie dem Discord bei für Updates, Vorschläge und Fehlerberichte",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Heute Gefangen",
    last_7_days: "Letzte 7 Tage",
    last_30_days: "Letzte 30 Tage",
    last_week: "Letzte Woche",
    last_month: "Letzter Monat",
    last_year: "Letztes Jahr",
    custom_age: "Benutzerdefiniertes Alter",
    today: "Heute",
    more_than_days_ago: "Vor mehr als {days} Tagen",
    days_ago: "Vor {start}-{end} Tagen",
    last_days: "Letzte {days} Tage",
    age_label: "Alter {value}",
    distance_1000km_plus: "Distanz 1000km+",
    distance_100km_plus: "Distanz 100km+",
    include: "Einschließen",
    exclude: "Ausschließen",
    custom_date_range: "Benutzerdefinierter Datumsbereich",
    examples: "Beispiele",
    invalid_format: "Ungültiges Format. Verwenden Sie: Zahl (z.B. 30), Bereich (z.B. 0-7) oder Altersformat (z.B. age0-30)",
    generations: "Generationen",
    pokemon_groups: "Pokémon-Gruppen",
    gen_1_kanto: "Gen 1 (Kanto)",
    gen_2_johto: "Gen 2 (Johto)",
    gen_3_hoenn: "Gen 3 (Hoenn)",
    gen_4_sinnoh: "Gen 4 (Sinnoh)",
    gen_5_unova: "Gen 5 (Unova)",
    gen_6_kalos: "Gen 6 (Kalos)",
    gen_7_alola: "Gen 7 (Alola)",
    gen_8_galar: "Gen 8 (Galar)",
    all_starters: "Alle Starter",
    kanto_starters: "Kanto-Starter",
    johto_starters: "Johto-Starter",
    hoenn_starters: "Hoenn-Starter",
    sinnoh_starters: "Sinnoh-Starter",
    unova_starters: "Einall-Starter",
    kalos_starters: "Kalos-Starter",
    alola_starters: "Alola-Starter",
    galar_starters: "Galar-Starter",
    pseudo_legendaries: "Pseudo-Legendäre",
    eeveelutions: "Evoli-Entwicklungen",
    quick_combos: "Schnelle Kombos",
    quick_combos_info: "Diese Buttons fügen Filterkombinationen zu Ihrer bestehenden Suchzeichenfolge hinzu und ermöglichen es Ihnen, mehrere Kombos zu stapeln.",
    shiny_legendaries: "Schillernde Legendäre",
    shiny_legendaries_desc: "Alle schillernden legendären Pokémon",
    perfect_shadows: "Perfekte Schatten",
    perfect_shadows_desc: "Schatten-Pokémon mit 100% IV",
    high_iv_non_shiny: "Hohe IV Nicht-Schillernd",
    high_iv_non_shiny_desc: "3-4★ Pokémon, die nicht schillernd sind",
    trade_fodder: "Tauschmaterial",
    trade_fodder_desc: "Niedrige IV Nicht-Favoriten zum Tauschen",
    recent_catches: "Kürzliche Fänge",
    recent_catches_desc: "Pokémon, die in der letzten Woche gefangen wurden",
    evolution_ready: "Evolutionsbereit",
    evolution_ready_desc: "Kann sich entwickeln, nicht favorisiert",
    shiny_costume: "Schillerndes Kostüm",
    shiny_costume_desc: "Schillernde Pokémon mit Kostümen",
    legendary_non_shiny: "Legendär Nicht-Schillernd",
    legendary_non_shiny_desc: "Legendäre, die Sie noch nicht schillernd gefunden haben",
    pvp_league_cp_caps: "KP-Obergrenzen der PvP-Ligen",
    pvp_league_cp_caps_desc: "Dies sind die wettbewerbsfähigen KP-Obergrenzen der PvP-Ligen, die in Pokémon GO verwendet werden. Durch Klicken auf einen Button wird der KP-Bereich in Ihrer Suchzeichenfolge eingefügt oder ersetzt.",
    great_league: "Superliga",
    great_league_cp: "KP 0-1500",
    ultra_league: "Hyperliga",
    ultra_league_cp: "KP 0-2500",
    master_league: "Meisterliga",
    master_league_cp: "KP 2500+",
    under_500_cp: "Unter 500 KP",
    under_500_cp_value: "KP 0-500",
    high_cp: "Hohes KP",
    high_cp_value: "KP 3000+",
    perfect_cp: "Perfektes KP",
    perfect_cp_value: "KP 4000+",
    premade_section_title: "Raid-Stufen, PvP und häufige Kombinationen",
    premade_pvp_competitive: "PvP & Wettkampf",
    premade_raid_attackers: "Raid-Stufen Angreifer",
    premade_master_league: "PvP Meisterliga",
    premade_common_combos: "Häufige Kombinationen",
    info_shadow_vs_nonshadow_title: "Schatten vs Nicht-Schatten",
    info_shadow_vs_nonshadow_text: "Pokémon GO kann Schatten- und Nicht-Schatten-Versionen nicht gleichzeitig anzeigen. Verwenden Sie separate Suchen.",
    info_master_league_title: "Meisterliga-Ranglisten",
    info_master_league_text: "Basierend auf PvP-Ranglisten der Meisterliga für Wettkampfkämpfe. Enthält Top-gerankte Pokémon wie Zacian (Gekröntes Schwert), Palkia (Ursprung & Schatten), Zamazenta (Gekrönter Schild), Dialga (Ursprung & Schatten), Kyurem (Weiß & Schwarz), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss und Solgaleo.",
    tier_s_label: "S-Stufe",
    tier_s_description: "Gipfel der Macht",
    tier_aplus_label: "A+-Stufe",
    tier_aplus_description: "Stehen an oder Nahe der Spitze",
    tier_a_label: "A-Stufe",
    tier_a_description: "Gold-Standard Investition",
    badge_shadow: "CRYPTO",
    badge_mega: "MEGA",
    badge_mega_primal: "MEGA/PROTO",
    premade_s_tier_shadows: "S-Stufe Schatten",
    premade_s_tier_shadows_desc: "Schatten-Pokémon - Gipfel der Macht",
    premade_s_tier_nonshadow: "S-Stufe Nicht-Schatten",
    premade_s_tier_nonshadow_desc: "Mega/Primal-Pokémon - höchste Prioritäten",
    premade_aplus_tier_shadows: "A+-Stufe Schatten",
    premade_aplus_tier_shadows_desc: "Schatten-Pokémon - stehen an oder nahe der Spitze",
    premade_aplus_tier_nonshadow: "A+-Stufe Nicht-Schatten",
    premade_aplus_tier_nonshadow_desc: "Mega-Pokémon - stehen an oder nahe der Spitze",
    premade_a_tier_shadows: "A-Stufe Schatten",
    premade_a_tier_shadows_desc: "Schatten-Pokémon - Gold-Standard investitionswürdig",
    premade_a_tier_nonshadow: "A-Stufe Nicht-Schatten",
    premade_a_tier_nonshadow_desc: "Mega-Pokémon - Gold-Standard investitionswürdig",
    premade_top25_master_league: "Top 25 Meisterliga",
    premade_top25_master_league_desc: "Top-gerankte Pokémon für Wettkampfkämpfe PvP Meisterliga"
  },
  "Italian": {
    app_title: "Costruttore di Ricerca Pokémon GO",
    app_subtitle: "Crea stringhe di ricerca visivamente",
    search_string: "Stringa di Ricerca",
    search_placeholder: "La tua stringa di ricerca apparirà qui...",
    filter_search_placeholder: "Cerca filtri... (es., 'shiny')",
    stats_ivs: "Statistiche e IV",
    types: "Tipi",
    special_status: "Stato Speciale",
    evolution_buddy: "Evoluzione e Compagno",
    time_distance: "Tempo e Distanza",
    size_gender: "Dimensione e Genere",
    moves: "Mosse",
    regions: "Regioni",
    clear_all: "Cancella Tutto",
    copy: "Copia",
    copied: "Copiato!",
    copy_has_issues: "Copia (Ha problemi)",
    validation_error_title: "⚠️ Questa ricerca non funzionerà in Pokémon GO",
    validation_error_subtitle: "Queste combinazioni sono impossibili, ma puoi comunque copiare se vuoi sperimentare.",
    validation_why_label: "Perché non funzionerà:",
    validation_fix_label: "✓ Come risolvere:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "Attacco Perfetto (15)",
    filter_3attack: "Attacco Alto (12-14)",
    filter_4defense: "Difesa Perfetta (15)",
    filter_3defense: "Difesa Alta (12-14)",
    filter_4hp: "PS Perfetti (15)",
    filter_3hp: "PS Alti (12-14)",
    filter_0attack: "Attacco Zero",
    filter_0defense: "Difesa Zero",
    filter_0hp: "PS Zero",
    filter_shiny: "Cromatico",
    filter_lucky: "Fortunato",
    filter_shadow: "Ombra",
    filter_purified: "Purificato",
    filter_legendary: "Leggendario",
    filter_mythical: "Mitico",
    save_this_search: "Salva questa ricerca",
    search_saved: "Ricerca salvata!",
    active: "attivo",
    light_mode: "Modalità chiara",
    dark_mode: "Modalità scura",
    translation_warnings: "Avvisi di Traduzione:",
    conflicting_filters: "Filtri in Conflitto",
    remove_spaces: "Rimuovi spazi dalla stringa di ricerca",
    missing_ampersand: "& mancante tra i filtri",
    use_commas: "Usa virgole tra i numeri del Pokédex, non &",
    quick_searches: "Ricerche Rapide",
    cp_ranges: "Intervalli di PC",
    pokemon_selection: "Selezione Pokémon",
    pokemon_groups: "Gruppi Pokémon",
    insert_cp_range: "Inserisci intervalli di PC per leghe PvP",
    quick_insert_pokemon: "Inserimento rapido di intervalli e gruppi Pokémon",
    saved_searches: "Ricerche Salvate",
    import_searches: "Importa ricerche",
    export_searches: "Esporta ricerche",
    delete_saved_search: "Elimina ricerca salvata",
    storage_limit_reached: "Limite di archiviazione raggiunto. Elimina alcune ricerche salvate.",
    failed_import: "Importazione ricerche salvate fallita. Verifica il formato del file.",
    language: "Lingua",
    language_wip: "(WIP)",
    join_discord: "Unisciti al Discord per aggiornamenti, suggerimenti e segnalazioni di bug",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Catturato Oggi",
    last_7_days: "Ultimi 7 Giorni",
    last_30_days: "Ultimi 30 Giorni",
    last_week: "Ultima Settimana",
    last_month: "Ultimo Mese",
    last_year: "Ultimo Anno",
    custom_age: "Età Personalizzata",
    today: "Oggi",
    more_than_days_ago: "Più di {days} giorni fa",
    days_ago: "{start}-{end} giorni fa",
    last_days: "Ultimi {days} giorni",
    age_label: "Età {value}",
    distance_1000km_plus: "Distanza 1000km+",
    distance_100km_plus: "Distanza 100km+",
    include: "Includi",
    exclude: "Escludi",
    custom_date_range: "Intervallo di Date Personalizzato",
    examples: "Esempi",
    invalid_format: "Formato non valido. Usa: numero (es., 30), intervallo (es., 0-7), o formato età (es., age0-30)",
    generations: "Generazioni",
    pokemon_groups: "Gruppi Pokémon",
    gen_1_kanto: "Gen 1 (Kanto)",
    gen_2_johto: "Gen 2 (Johto)",
    gen_3_hoenn: "Gen 3 (Hoenn)",
    gen_4_sinnoh: "Gen 4 (Sinnoh)",
    gen_5_unova: "Gen 5 (Unova)",
    gen_6_kalos: "Gen 6 (Kalos)",
    gen_7_alola: "Gen 7 (Alola)",
    gen_8_galar: "Gen 8 (Galar)",
    all_starters: "Tutti gli Starter",
    kanto_starters: "Starter di Kanto",
    johto_starters: "Starter di Johto",
    hoenn_starters: "Starter di Hoenn",
    sinnoh_starters: "Starter di Sinnoh",
    unova_starters: "Starter di Unima",
    kalos_starters: "Starter di Kalos",
    alola_starters: "Starter di Alola",
    galar_starters: "Starter di Galar",
    pseudo_legendaries: "Pseudo-Leggendari",
    eeveelutions: "Evoluzioni di Eevee",
    quick_combos: "Combinazioni Rapide",
    quick_combos_info: "Questi pulsanti aggiungono combinazioni di filtri alla tua stringa di ricerca esistente, permettendoti di impilare più combinazioni insieme.",
    shiny_legendaries: "Leggendari Lucenti",
    shiny_legendaries_desc: "Tutti i Pokémon leggendari lucenti",
    perfect_shadows: "Ombre Perfette",
    perfect_shadows_desc: "Pokémon ombra con IV al 100%",
    high_iv_non_shiny: "Alto IV Non Lucente",
    high_iv_non_shiny_desc: "Pokémon 3-4★ che non sono lucenti",
    trade_fodder: "Materiale da Scambio",
    trade_fodder_desc: "Basso IV non preferiti per lo scambio",
    recent_catches: "Catture Recenti",
    recent_catches_desc: "Pokémon catturati nell'ultima settimana",
    evolution_ready: "Pronto all'Evoluzione",
    evolution_ready_desc: "Può evolversi, non preferito",
    shiny_costume: "Costume Lucente",
    shiny_costume_desc: "Pokémon lucenti con costumi",
    legendary_non_shiny: "Leggendario Non Lucente",
    legendary_non_shiny_desc: "Leggendari che non hai trovato lucenti",
    pvp_league_cp_caps: "Limiti CP delle Leghe PvP",
    pvp_league_cp_caps_desc: "Questi sono i limiti CP competitivi delle leghe PvP usati in Pokémon GO. Cliccare su un pulsante inserirà o sostituirà l'intervallo CP nella tua stringa di ricerca.",
    great_league: "Lega Super",
    great_league_cp: "PC 0-1500",
    ultra_league: "Lega Iper",
    ultra_league_cp: "PC 0-2500",
    master_league: "Lega Master",
    master_league_cp: "PC 2500+",
    under_500_cp: "Sotto 500 PC",
    under_500_cp_value: "PC 0-500",
    high_cp: "Alto PC",
    high_cp_value: "PC 3000+",
    perfect_cp: "PC Perfetto",
    perfect_cp_value: "PC 4000+",
    premade_section_title: "Livelli raid, PvP e combo comuni",
    premade_pvp_competitive: "PvP e Competitivo",
    premade_raid_attackers: "Attaccanti di livello raid",
    premade_master_league: "PvP Lega Master",
    premade_common_combos: "Combo Comuni",
    info_shadow_vs_nonshadow_title: "Ombra vs Non Ombra",
    info_shadow_vs_nonshadow_text: "Pokémon GO non può mostrare versioni Ombra e non Ombra contemporaneamente. Usa ricerche separate.",
    info_master_league_title: "Classifiche Lega Master",
    info_master_league_text: "Basato sulle classifiche PvP della Lega Master per le lotte competitive. Include Pokémon di alto livello come Zacian (Spada del Re), Palkia (Origine e Ombra), Zamazenta (Scudo del Re), Dialga (Origine e Ombra), Kyurem (Bianco e Nero), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss e Solgaleo.",
    tier_s_label: "Livello S",
    tier_s_description: "Apice della Potenza",
    tier_aplus_label: "Livello A+",
    tier_aplus_description: "Ai vertici o vicino alla cima",
    tier_a_label: "Livello A",
    tier_a_description: "Investimento standard d'oro",
    badge_shadow: "OMBRA",
    badge_mega: "MEGA",
    badge_mega_primal: "MEGA/PRIMORDIALE",
    premade_s_tier_shadows: "Ombre di Livello S",
    premade_s_tier_shadows_desc: "Pokémon Ombra - apice della potenza",
    premade_s_tier_nonshadow: "Non Ombra di Livello S",
    premade_s_tier_nonshadow_desc: "Pokémon Mega/Primordiali - priorità assolute",
    premade_aplus_tier_shadows: "Ombre di Livello A+",
    premade_aplus_tier_shadows_desc: "Pokémon Ombra - restano al top",
    premade_aplus_tier_nonshadow: "Non Ombra di Livello A+",
    premade_aplus_tier_nonshadow_desc: "Pokémon Mega - restano al top",
    premade_a_tier_shadows: "Ombre di Livello A",
    premade_a_tier_shadows_desc: "Pokémon Ombra - investimento standard d'oro",
    premade_a_tier_nonshadow: "Non Ombra di Livello A",
    premade_a_tier_nonshadow_desc: "Pokémon Mega - investimento standard d'oro",
    premade_top25_master_league: "Top 25 Lega Master",
    premade_top25_master_league_desc: "Pokémon meglio classificati per il PvP della Lega Master"
  },
  "Japanese": {
    app_title: "ポケモンGO検索ビルダー",
    app_subtitle: "検索文字列を視覚的に作成",
    search_string: "検索文字列",
    search_placeholder: "検索文字列がここに表示されます...",
    filter_search_placeholder: "フィルターを検索...（例：'shiny'）",
    stats_ivs: "ステータスと個体値",
    types: "タイプ",
    special_status: "特別な状態",
    evolution_buddy: "進化とバディ",
    time_distance: "時間と距離",
    size_gender: "サイズと性別",
    moves: "わざ",
    regions: "地方",
    clear_all: "すべてクリア",
    copy: "コピー",
    copied: "コピーしました！",
    copy_has_issues: "コピー（問題あり）",
    validation_error_title: "⚠️ この検索はポケモンGOで動作しません",
    validation_error_subtitle: "これらの組み合わせは不可能ですが、実験したい場合はコピーできます。",
    validation_why_label: "なぜ機能しないのか:",
    validation_fix_label: "✓ 修正方法:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "完璧な攻撃 (15)",
    filter_3attack: "高い攻撃 (12-14)",
    filter_4defense: "完璧な防御 (15)",
    filter_3defense: "高い防御 (12-14)",
    filter_4hp: "完璧なHP (15)",
    filter_3hp: "高いHP (12-14)",
    filter_0attack: "攻撃ゼロ",
    filter_0defense: "防御ゼロ",
    filter_0hp: "HPゼロ",
    filter_shiny: "色違い",
    filter_lucky: "ラッキー",
    filter_shadow: "シャドウ",
    filter_purified: "浄化済み",
    filter_legendary: "伝説",
    filter_mythical: "幻",
    save_this_search: "この検索を保存",
    search_saved: "検索を保存しました！",
    active: "アクティブ",
    light_mode: "ライトモード",
    dark_mode: "ダークモード",
    translation_warnings: "翻訳警告：",
    conflicting_filters: "競合するフィルター",
    remove_spaces: "検索文字列からスペースを削除",
    missing_ampersand: "フィルター間に&がありません",
    use_commas: "ポケモン図鑑番号の間は&ではなくカンマを使用",
    quick_searches: "クイック検索",
    cp_ranges: "CP範囲",
    pokemon_selection: "ポケモン選択",
    pokemon_groups: "ポケモングループ",
    insert_cp_range: "PvPリーグ用のCP範囲を挿入",
    quick_insert_pokemon: "ポケモンの範囲とグループをすばやく挿入",
    saved_searches: "保存された検索",
    import_searches: "検索をインポート",
    export_searches: "検索をエクスポート",
    delete_saved_search: "保存された検索を削除",
    storage_limit_reached: "ストレージ制限に達しました。保存された検索をいくつか削除してください。",
    failed_import: "保存された検索のインポートに失敗しました。ファイル形式を確認してください。",
    language: "言語",
    language_wip: "(WIP)",
    join_discord: "更新、提案、バグレポートのためにDiscordに参加",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "今日捕獲",
    last_7_days: "過去7日間",
    last_30_days: "過去30日間",
    last_week: "先週",
    last_month: "先月",
    last_year: "去年",
    custom_age: "カスタム年齢",
    today: "今日",
    more_than_days_ago: "{days}日以上前",
    days_ago: "{start}-{end}日前",
    last_days: "過去{days}日間",
    age_label: "年齢 {value}",
    distance_1000km_plus: "距離1000km以上",
    distance_100km_plus: "距離100km以上",
    include: "含める",
    exclude: "除外",
    custom_date_range: "カスタム日付範囲",
    examples: "例",
    invalid_format: "無効な形式。使用: 数字（例：30）、範囲（例：0-7）、または年齢形式（例：age0-30）",
    generations: "世代",
    pokemon_groups: "ポケモングループ",
    gen_1_kanto: "第1世代（カントー）",
    gen_2_johto: "第2世代（ジョウト）",
    gen_3_hoenn: "第3世代（ホウエン）",
    gen_4_sinnoh: "第4世代（シンオウ）",
    gen_5_unova: "第5世代（イッシュ）",
    gen_6_kalos: "第6世代（カロス）",
    gen_7_alola: "第7世代（アローラ）",
    gen_8_galar: "第8世代（ガラル）",
    all_starters: "すべての御三家",
    kanto_starters: "カントー御三家",
    johto_starters: "ジョウト御三家",
    hoenn_starters: "ホウエン御三家",
    sinnoh_starters: "シンオウ御三家",
    unova_starters: "イッシュ御三家",
    kalos_starters: "カロス御三家",
    alola_starters: "アローラ御三家",
    galar_starters: "ガラル御三家",
    pseudo_legendaries: "準伝説",
    eeveelutions: "イーブイ進化系",
    quick_combos: "クイックコンボ",
    quick_combos_info: "これらのボタンは、既存の検索文字列にフィルターの組み合わせを追加し、複数のコンボを一緒に積み重ねることができます。",
    shiny_legendaries: "色違い伝説",
    shiny_legendaries_desc: "すべての色違い伝説ポケモン",
    perfect_shadows: "完璧なシャドウ",
    perfect_shadows_desc: "100%個体値のシャドウポケモン",
    high_iv_non_shiny: "高個体値非色違い",
    high_iv_non_shiny_desc: "色違いではない3-4★ポケモン",
    trade_fodder: "交換用",
    trade_fodder_desc: "交換用の低個体値非お気に入り",
    recent_catches: "最近の捕獲",
    recent_catches_desc: "先週捕獲したポケモン",
    evolution_ready: "進化準備完了",
    evolution_ready_desc: "進化可能、お気に入りではない",
    shiny_costume: "色違いコスチューム",
    shiny_costume_desc: "コスチューム付き色違いポケモン",
    legendary_non_shiny: "非色違い伝説",
    legendary_non_shiny_desc: "まだ色違いを見つけていない伝説",
    pvp_league_cp_caps: "PvPリーグCP上限",
    pvp_league_cp_caps_desc: "これらはポケモンGOで使用される競技PvPリーグのCP上限です。ボタンをクリックすると、検索文字列にCP範囲が挿入または置換されます。",
    great_league: "スーパーリーグ",
    great_league_cp: "CP 0-1500",
    ultra_league: "ハイパーリーグ",
    ultra_league_cp: "CP 0-2500",
    master_league: "マスターリーグ",
    master_league_cp: "CP 2500+",
    under_500_cp: "500 CP未満",
    under_500_cp_value: "CP 0-500",
    high_cp: "高CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "完璧なCP",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "レイド階層、PvP、定番コンボ",
    premade_pvp_competitive: "PvP・競技",
    premade_raid_attackers: "レイド階層アタッカー",
    premade_master_league: "PvPマスターリーグ",
    premade_common_combos: "定番コンボ",
    info_shadow_vs_nonshadow_title: "シャドウ vs 非シャドウ",
    info_shadow_vs_nonshadow_text: "Pokémon GO はシャドウと通常を同時に表示できません。検索を分けてください。",
    info_master_league_title: "マスターリーグランキング",
    info_master_league_text: "競技PvP向けのマスターリーグランキングに基づいています。ザシアン（王の剣）、パルキア（オリジン/シャドウ）、ザマゼンタ（王の盾）、ディアルガ（オリジン/シャドウ）、キュレム（ホワイト/ブラック）、ゼクロム、レシラム、ルギア、メタグロス、エターナル、ネクロズマ、ルナアーラ、ホウオウ、グラードン、ラティオス、メロエッタ、フラージェス、トゲキッス、ソルガレオなどを含みます。",
    tier_s_label: "Sランク",
    tier_s_description: "力の頂点",
    tier_aplus_label: "A+ランク",
    tier_aplus_description: "トップまたはその近く",
    tier_a_label: "Aランク",
    tier_a_description: "投資価値の黄金基準",
    badge_shadow: "シャドウ",
    badge_mega: "メガ",
    badge_mega_primal: "メガ/ゲンシ",
    premade_s_tier_shadows: "Sランクシャドウ",
    premade_s_tier_shadows_desc: "シャドウポケモン - 力の頂点",
    premade_s_tier_nonshadow: "Sランク非シャドウ",
    premade_s_tier_nonshadow_desc: "メガ/ゲンシポケモン - 最優先",
    premade_aplus_tier_shadows: "A+ランクシャドウ",
    premade_aplus_tier_shadows_desc: "シャドウポケモン - トップクラス",
    premade_aplus_tier_nonshadow: "A+ランク非シャドウ",
    premade_aplus_tier_nonshadow_desc: "メガポケモン - トップクラス",
    premade_a_tier_shadows: "Aランクシャドウ",
    premade_a_tier_shadows_desc: "シャドウポケモン - 黄金基準の投資価値",
    premade_a_tier_nonshadow: "Aランク非シャドウ",
    premade_a_tier_nonshadow_desc: "メガポケモン - 黄金基準の投資価値",
    premade_top25_master_league: "トップ25マスターリーグ",
    premade_top25_master_league_desc: "マスターリーグPvP競技バトル向けの上位ポケモン"
  },
  "Korean": {
    app_title: "포켓몬GO 검색 빌더",
    app_subtitle: "검색 문자열을 시각적으로 만들기",
    search_string: "검색 문자열",
    search_placeholder: "검색 문자열이 여기에 표시됩니다...",
    filter_search_placeholder: "필터 검색... (예: 'shiny')",
    stats_ivs: "스탯 및 개체값",
    types: "타입",
    special_status: "특수 상태",
    evolution_buddy: "진화 및 버디",
    time_distance: "시간 및 거리",
    size_gender: "크기 및 성별",
    moves: "기술",
    regions: "지역",
    clear_all: "모두 지우기",
    copy: "복사",
    copied: "복사됨!",
    copy_has_issues: "복사 (문제 있음)",
    validation_error_title: "⚠️ 이 검색은 포켓몬 GO에서 작동하지 않습니다",
    validation_error_subtitle: "이 조합은 불가능하지만 실험하고 싶다면 여전히 복사할 수 있습니다.",
    validation_why_label: "작동하지 않는 이유:",
    validation_fix_label: "✓ 수정 방법:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "완벽한 공격 (15)",
    filter_3attack: "높은 공격 (12-14)",
    filter_4defense: "완벽한 방어 (15)",
    filter_3defense: "높은 방어 (12-14)",
    filter_4hp: "완벽한 HP (15)",
    filter_3hp: "높은 HP (12-14)",
    filter_0attack: "공격 0",
    filter_0defense: "방어 0",
    filter_0hp: "HP 0",
    filter_shiny: "색이 다른",
    filter_lucky: "럭키",
    filter_shadow: "그림자",
    filter_purified: "정화됨",
    filter_legendary: "전설",
    filter_mythical: "환상",
    save_this_search: "이 검색 저장",
    search_saved: "검색 저장됨!",
    active: "활성",
    light_mode: "라이트 모드",
    dark_mode: "다크 모드",
    translation_warnings: "번역 경고:",
    conflicting_filters: "충돌하는 필터",
    remove_spaces: "검색 문자열에서 공백 제거",
    missing_ampersand: "필터 사이에 &가 없습니다",
    use_commas: "도감 번호 사이에 & 대신 쉼표 사용",
    quick_searches: "빠른 검색",
    cp_ranges: "CP 범위",
    pokemon_selection: "포켓몬 선택",
    pokemon_groups: "포켓몬 그룹",
    insert_cp_range: "PvP 리그용 CP 범위 삽입",
    quick_insert_pokemon: "포켓몬 범위 및 그룹 빠른 삽입",
    saved_searches: "저장된 검색",
    import_searches: "검색 가져오기",
    export_searches: "검색 내보내기",
    delete_saved_search: "저장된 검색 삭제",
    storage_limit_reached: "저장소 제한에 도달했습니다. 저장된 검색을 일부 삭제하세요.",
    failed_import: "저장된 검색 가져오기 실패. 파일 형식을 확인하세요.",
    language: "언어",
    language_wip: "(WIP)",
    join_discord: "업데이트, 제안 및 버그 보고를 위해 Discord에 참여",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "오늘 잡음",
    last_7_days: "지난 7일",
    last_30_days: "지난 30일",
    last_week: "지난 주",
    last_month: "지난 달",
    last_year: "작년",
    custom_age: "사용자 정의 나이",
    today: "오늘",
    more_than_days_ago: "{days}일 이상 전",
    days_ago: "{start}-{end}일 전",
    last_days: "지난 {days}일",
    age_label: "나이 {value}",
    distance_1000km_plus: "거리 1000km 이상",
    distance_100km_plus: "거리 100km 이상",
    include: "포함",
    exclude: "제외",
    custom_date_range: "사용자 정의 날짜 범위",
    examples: "예",
    invalid_format: "잘못된 형식. 사용: 숫자 (예: 30), 범위 (예: 0-7), 또는 나이 형식 (예: age0-30)",
    generations: "세대",
    pokemon_groups: "포켓몬 그룹",
    gen_1_kanto: "1세대 (관동)",
    gen_2_johto: "2세대 (성도)",
    gen_3_hoenn: "3세대 (호연)",
    gen_4_sinnoh: "4세대 (신오)",
    gen_5_unova: "5세대 (하나)",
    gen_6_kalos: "6세대 (칼로스)",
    gen_7_alola: "7세대 (알로라)",
    gen_8_galar: "8세대 (가라르)",
    all_starters: "모든 스타터",
    kanto_starters: "관동 스타터",
    johto_starters: "성도 스타터",
    hoenn_starters: "호연 스타터",
    sinnoh_starters: "신오 스타터",
    unova_starters: "하나 스타터",
    kalos_starters: "칼로스 스타터",
    alola_starters: "알로라 스타터",
    galar_starters: "가라르 스타터",
    pseudo_legendaries: "준전설",
    eeveelutions: "이브이 진화형",
    quick_combos: "빠른 조합",
    quick_combos_info: "이 버튼들은 기존 검색 문자열에 필터 조합을 추가하여 여러 조합을 함께 쌓을 수 있게 해줍니다.",
    shiny_legendaries: "색다른 전설",
    shiny_legendaries_desc: "모든 색다른 전설 포켓몬",
    perfect_shadows: "완벽한 그림자",
    perfect_shadows_desc: "100% 개체값 그림자 포켓몬",
    high_iv_non_shiny: "고개체값 비색다른",
    high_iv_non_shiny_desc: "색다르지 않은 3-4★ 포켓몬",
    trade_fodder: "교환용",
    trade_fodder_desc: "교환용 저개체값 비즐겨찾기",
    recent_catches: "최근 포획",
    recent_catches_desc: "지난 주에 포획한 포켓몬",
    evolution_ready: "진화 준비",
    evolution_ready_desc: "진화 가능, 즐겨찾기 아님",
    shiny_costume: "색다른 의상",
    shiny_costume_desc: "의상이 있는 색다른 포켓몬",
    legendary_non_shiny: "비색다른 전설",
    legendary_non_shiny_desc: "아직 색다른 것을 찾지 못한 전설",
    pvp_league_cp_caps: "PvP 리그 CP 상한",
    pvp_league_cp_caps_desc: "이것들은 포켓몬GO에서 사용되는 경쟁 PvP 리그 CP 상한입니다. 버튼을 클릭하면 검색 문자열에 CP 범위가 삽입되거나 교체됩니다.",
    great_league: "슈퍼리그",
    great_league_cp: "CP 0-1500",
    ultra_league: "하이퍼리그",
    ultra_league_cp: "CP 0-2500",
    master_league: "마스터리그",
    master_league_cp: "CP 2500+",
    under_500_cp: "500 CP 미만",
    under_500_cp_value: "CP 0-500",
    high_cp: "높은 CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "완벽한 CP",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "레이드 티어, PvP, 일반 조합",
    premade_pvp_competitive: "PvP 및 경쟁",
    premade_raid_attackers: "레이드 티어 공격수",
    premade_master_league: "마스터 리그 PvP",
    premade_common_combos: "일반 조합",
    info_shadow_vs_nonshadow_title: "섀도우 vs 비섀도우",
    info_shadow_vs_nonshadow_text: "포켓몬 GO는 섀도우와 비섀도우 버전을 동시에 표시할 수 없습니다. 별도의 검색을 사용하세요.",
    info_master_league_title: "마스터 리그 랭킹",
    info_master_league_text: "경쟁 PvP 배틀을 위한 마스터 리그 랭킹을 기반으로 합니다. 자시안(왕의 검), 펄기아(오리진 & 섀도우), 자마젠타(왕의 방패), 디아루가(오리진 & 섀도우), 큐레무(화이트 & 블랙), 제크로무, 레시라무, 루기아, 메타그로스, 에터너스, 네크로즈마, 루날라, 호오, 그라돈, 라티오스, 멜로에타, 플로르제스, 토게키스, 솔가레오 등이 포함됩니다.",
    tier_s_label: "S 티어",
    tier_s_description: "힘의 정점",
    tier_aplus_label: "A+ 티어",
    tier_aplus_description: "정상 혹은 그 근처",
    tier_a_label: "A 티어",
    tier_a_description: "골드 스탠다드 투자",
    badge_shadow: "섀도우",
    badge_mega: "메가",
    badge_mega_primal: "메가/원시",
    premade_s_tier_shadows: "S 티어 섀도우",
    premade_s_tier_shadows_desc: "섀도우 포켓몬 - 힘의 정점",
    premade_s_tier_nonshadow: "S 티어 비섀도우",
    premade_s_tier_nonshadow_desc: "메가/원시 포켓몬 - 최우선 과제",
    premade_aplus_tier_shadows: "A+ 티어 섀도우",
    premade_aplus_tier_shadows_desc: "섀도우 포켓몬 - 정상급 유지",
    premade_aplus_tier_nonshadow: "A+ 티어 비섀도우",
    premade_aplus_tier_nonshadow_desc: "메가 포켓몬 - 정상급 유지",
    premade_a_tier_shadows: "A 티어 섀도우",
    premade_a_tier_shadows_desc: "섀도우 포켓몬 - 투자 가치",
    premade_a_tier_nonshadow: "A 티어 비섀도우",
    premade_a_tier_nonshadow_desc: "메가 포켓몬 - 투자 가치",
    premade_top25_master_league: "마스터 리그 상위 25",
    premade_top25_master_league_desc: "마스터 리그 PvP 경쟁을 위한 상위 포켓몬"
  },
  "Russian": {
    app_title: "Конструктор Поиска Pokémon GO",
    app_subtitle: "Создавайте поисковые строки визуально",
    search_string: "Поисковая Строка",
    search_placeholder: "Ваша поисковая строка появится здесь...",
    filter_search_placeholder: "Поиск фильтров... (напр., 'shiny')",
    stats_ivs: "Характеристики и ИВ",
    types: "Типы",
    special_status: "Особый Статус",
    evolution_buddy: "Эволюция и Напарник",
    time_distance: "Время и Расстояние",
    size_gender: "Размер и Пол",
    moves: "Атаки",
    regions: "Регионы",
    clear_all: "Очистить Всё",
    copy: "Копировать",
    copied: "Скопировано!",
    copy_has_issues: "Копировать (Есть проблемы)",
    validation_error_title: "⚠️ Этот поиск не будет работать в Pokémon GO",
    validation_error_subtitle: "Эти комбинации невозможны, но вы все равно можете скопировать, если хотите поэкспериментировать.",
    validation_why_label: "Почему это не сработает:",
    validation_fix_label: "✓ Как исправить:",
    filter_4star: "4★ (100% ИВ)",
    filter_3star: "3★ (82-98% ИВ)",
    filter_2star: "2★ (67-80% ИВ)",
    filter_1star: "1★ (51-64% ИВ)",
    filter_0star: "0★ (0-49% ИВ)",
    filter_4attack: "Идеальная Атака (15)",
    filter_3attack: "Высокая Атака (12-14)",
    filter_4defense: "Идеальная Защита (15)",
    filter_3defense: "Высокая Защита (12-14)",
    filter_4hp: "Идеальное Здоровье (15)",
    filter_3hp: "Высокое Здоровье (12-14)",
    filter_0attack: "Ноль Атаки",
    filter_0defense: "Ноль Защиты",
    filter_0hp: "Ноль Здоровья",
    filter_shiny: "Блестящий",
    filter_lucky: "Удачливый",
    filter_shadow: "Теневой",
    filter_purified: "Очищенный",
    filter_legendary: "Легендарный",
    filter_mythical: "Мифический",
    save_this_search: "Сохранить этот поиск",
    search_saved: "Поиск сохранён!",
    active: "активно",
    light_mode: "Светлый режим",
    dark_mode: "Тёмный режим",
    translation_warnings: "Предупреждения Перевода:",
    conflicting_filters: "Конфликтующие Фильтры",
    remove_spaces: "Удалить пробелы из поисковой строки",
    missing_ampersand: "Отсутствует & между фильтрами",
    use_commas: "Используйте запятые между номерами Покéдекса, а не &",
    quick_searches: "Быстрый Поиск",
    cp_ranges: "Диапазоны СР",
    pokemon_selection: "Выбор Покémon",
    pokemon_groups: "Группы Покémon",
    insert_cp_range: "Вставить диапазоны СР для PvP лиг",
    quick_insert_pokemon: "Быстрая вставка диапазонов и групп Покémon",
    saved_searches: "Сохранённые Поиски",
    import_searches: "Импортировать поиски",
    export_searches: "Экспортировать поиски",
    delete_saved_search: "Удалить сохранённый поиск",
    storage_limit_reached: "Достигнут лимит хранилища. Удалите некоторые сохранённые поиски.",
    failed_import: "Не удалось импортировать сохранённые поиски. Проверьте формат файла.",
    language: "Язык",
    language_wip: "(WIP)",
    join_discord: "Присоединяйтесь к Discord для обновлений, предложений и отчётов об ошибках",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Поймано Сегодня",
    last_7_days: "Последние 7 Дней",
    last_30_days: "Последние 30 Дней",
    last_week: "Прошлая Неделя",
    last_month: "Прошлый Месяц",
    last_year: "Прошлый Год",
    custom_age: "Пользовательский Возраст",
    today: "Сегодня",
    more_than_days_ago: "Более {days} дней назад",
    days_ago: "{start}-{end} дней назад",
    last_days: "Последние {days} дней",
    age_label: "Возраст {value}",
    distance_1000km_plus: "Расстояние 1000км+",
    distance_100km_plus: "Расстояние 100км+",
    include: "Включить",
    exclude: "Исключить",
    custom_date_range: "Пользовательский Диапазон Дат",
    examples: "Примеры",
    invalid_format: "Неверный формат. Используйте: число (напр., 30), диапазон (напр., 0-7), или формат возраста (напр., age0-30)",
    generations: "Поколения",
    pokemon_groups: "Группы Покémon",
    gen_1_kanto: "Поколение 1 (Канто)",
    gen_2_johto: "Поколение 2 (Джото)",
    gen_3_hoenn: "Поколение 3 (Хоэнн)",
    gen_4_sinnoh: "Поколение 4 (Синно)",
    gen_5_unova: "Поколение 5 (Унова)",
    gen_6_kalos: "Поколение 6 (Калос)",
    gen_7_alola: "Поколение 7 (Алола)",
    gen_8_galar: "Поколение 8 (Галар)",
    all_starters: "Все Стартовые",
    kanto_starters: "Стартовые Канто",
    johto_starters: "Стартовые Джото",
    hoenn_starters: "Стартовые Хоэнн",
    sinnoh_starters: "Стартовые Синно",
    unova_starters: "Стартовые Унова",
    kalos_starters: "Стартовые Калос",
    alola_starters: "Стартовые Алола",
    galar_starters: "Стартовые Галар",
    pseudo_legendaries: "Псевдо-Легендарные",
    eeveelutions: "Эволюции Иви",
    quick_combos: "Быстрые Комбо",
    quick_combos_info: "Эти кнопки добавляют комбинации фильтров к вашей существующей поисковой строке, позволяя вам складывать несколько комбо вместе.",
    shiny_legendaries: "Блестящие Легендарные",
    shiny_legendaries_desc: "Все блестящие легендарные Покémon",
    perfect_shadows: "Идеальные Тени",
    perfect_shadows_desc: "Теневые Покémon со 100% ИВ",
    high_iv_non_shiny: "Высокий ИВ Не Блестящий",
    high_iv_non_shiny_desc: "Покémon 3-4★, которые не блестящие",
    trade_fodder: "Материал для Обмена",
    trade_fodder_desc: "Низкий ИВ не избранные для обмена",
    recent_catches: "Недавние Поимки",
    recent_catches_desc: "Покémon, пойманные на прошлой неделе",
    evolution_ready: "Готов к Эволюции",
    evolution_ready_desc: "Может эволюционировать, не избран",
    shiny_costume: "Блестящий Костюм",
    shiny_costume_desc: "Блестящие Покémon с костюмами",
    legendary_non_shiny: "Легендарный Не Блестящий",
    legendary_non_shiny_desc: "Легендарные, которых вы ещё не нашли блестящими",
    pvp_league_cp_caps: "Пределы СР Лиг PvP",
    pvp_league_cp_caps_desc: "Это конкурентные пределы СР лиг PvP, используемые в Pokémon GO. Нажатие кнопки вставит или заменит диапазон СР в вашей поисковой строке.",
    great_league: "Супер Лига",
    great_league_cp: "СР 0-1500",
    ultra_league: "Гипер Лига",
    ultra_league_cp: "СР 0-2500",
    master_league: "Мастер Лига",
    master_league_cp: "СР 2500+",
    under_500_cp: "Менее 500 СР",
    under_500_cp_value: "СР 0-500",
    high_cp: "Высокий СР",
    high_cp_value: "СР 3000+",
    perfect_cp: "Идеальный СР",
    perfect_cp_value: "СР 4000+",
    premade_section_title: "Уровни рейдов, PvP и распространенные комбо",
    premade_pvp_competitive: "PvP и Соревновательный",
    premade_raid_attackers: "Атакующие Уровня Рейда",
    premade_master_league: "PvP Мастер Лига",
    premade_common_combos: "Распространенные Комбо",
    info_shadow_vs_nonshadow_title: "Тень vs Не-Тень",
    info_shadow_vs_nonshadow_text: "Pokémon GO не может отображать версии Тень и Не-Тень одновременно. Используйте отдельные поиски.",
    info_master_league_title: "Рейтинги Мастер Лиги",
    info_master_league_text: "Основано на рейтингах PvP Мастер Лиги для соревновательных боев. Включает топ-ранговых Покémon, таких как Зациан (Коронованный Меч), Палкия (Происхождение и Тень), Замазента (Коронованный Щит), Диалга (Происхождение и Тень), Кюрем (Белый и Черный), Зекром, Реширам, Лугия, Метагросс, Этернатус, Некрозма, Лунала, Хо-О, Гроудон, Латиос, Мелоэтта, Флоржес, Тогекисс и Сolgaleo.",
    tier_s_label: "S-Уровень",
    tier_s_description: "Вершина Силы",
    tier_aplus_label: "A+-Уровень",
    tier_aplus_description: "Стоят на или Близко к Вершине",
    tier_a_label: "A-Уровень",
    tier_a_description: "Золотой Стандарт Инвестиций",
    badge_shadow: "ТЕНЕВОЙ",
    badge_mega: "МЕГА",
    badge_mega_primal: "МЕГА/ПРАЙМАЛ",
    premade_s_tier_shadows: "S-Уровень Тени",
    premade_s_tier_shadows_desc: "Теневые Покémon - вершина силы",
    premade_s_tier_nonshadow: "S-Уровень Не-Тени",
    premade_s_tier_nonshadow_desc: "Мега/Праймал Покémon - высшие приоритеты",
    premade_aplus_tier_shadows: "A+-Уровень Тени",
    premade_aplus_tier_shadows_desc: "Теневые Покémon - стоят на или близко к вершине",
    premade_aplus_tier_nonshadow: "A+-Уровень Не-Тени",
    premade_aplus_tier_nonshadow_desc: "Мега Покémon - стоят на или близко к вершине",
    premade_a_tier_shadows: "A-Уровень Тени",
    premade_a_tier_shadows_desc: "Теневые Покémon - золотой стандарт достойный инвестиций",
    premade_a_tier_nonshadow: "A-Уровень Не-Тени",
    premade_a_tier_nonshadow_desc: "Мега Покémon - золотой стандарт достойный инвестиций",
    premade_top25_master_league: "Топ 25 Мастер Лига",
    premade_top25_master_league_desc: "Топ-ранговые Покémon для соревновательных боев PvP Мастер Лиги"
  },
  "Traditional Chinese": {
    app_title: "Pokémon GO 搜尋字串建立器",
    app_subtitle: "視覺化建立搜尋字串",
    search_string: "搜尋字串",
    search_placeholder: "您的搜尋字串將顯示在這裡...",
    filter_search_placeholder: "搜尋篩選器...（例如：'shiny'）",
    stats_ivs: "能力值與個體值",
    types: "屬性",
    special_status: "特殊狀態",
    evolution_buddy: "進化與夥伴",
    time_distance: "時間與距離",
    size_gender: "體型與性別",
    moves: "招式",
    regions: "地區",
    clear_all: "清除全部",
    copy: "複製",
    copied: "已複製！",
    copy_has_issues: "複製（有問題）",
    validation_error_title: "⚠️ 此搜尋在 Pokémon GO 中無法使用",
    validation_error_subtitle: "這些組合是不可能的，但如果你想實驗，仍然可以複製。",
    validation_why_label: "為什麼不會工作:",
    validation_fix_label: "✓ 如何修復:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "完美攻擊 (15)",
    filter_3attack: "高攻擊 (12-14)",
    filter_4defense: "完美防禦 (15)",
    filter_3defense: "高防禦 (12-14)",
    filter_4hp: "完美HP (15)",
    filter_3hp: "高HP (12-14)",
    filter_0attack: "零攻擊",
    filter_0defense: "零防禦",
    filter_0hp: "零HP",
    filter_shiny: "異色",
    filter_lucky: "幸運",
    filter_shadow: "暗影",
    filter_purified: "淨化",
    filter_legendary: "傳說",
    filter_mythical: "幻",
    save_this_search: "儲存此搜尋",
    search_saved: "搜尋已儲存！",
    active: "啟用",
    light_mode: "淺色模式",
    dark_mode: "深色模式",
    translation_warnings: "翻譯警告：",
    conflicting_filters: "衝突的篩選器",
    remove_spaces: "從搜尋字串中移除空格",
    missing_ampersand: "篩選器之間缺少 &",
    use_commas: "在圖鑑編號之間使用逗號，而非 &",
    quick_searches: "快速搜尋",
    cp_ranges: "CP 範圍",
    pokemon_selection: "寶可夢選擇",
    pokemon_groups: "寶可夢群組",
    insert_cp_range: "插入 PvP 聯盟的 CP 範圍",
    quick_insert_pokemon: "快速插入寶可夢範圍和群組",
    saved_searches: "已儲存的搜尋",
    import_searches: "匯入搜尋",
    export_searches: "匯出搜尋",
    delete_saved_search: "刪除已儲存的搜尋",
    storage_limit_reached: "已達到儲存限制。請刪除一些已儲存的搜尋。",
    failed_import: "匯入已儲存的搜尋失敗。請檢查檔案格式。",
    language: "語言",
    language_wip: "(WIP)",
    join_discord: "加入 Discord 以獲取更新、建議和錯誤回報",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "今天捕捉",
    last_7_days: "過去7天",
    last_30_days: "過去30天",
    last_week: "上週",
    last_month: "上個月",
    last_year: "去年",
    custom_age: "自訂年齡",
    today: "今天",
    more_than_days_ago: "{days}天以上前",
    days_ago: "{start}-{end}天前",
    last_days: "過去{days}天",
    age_label: "年齡 {value}",
    distance_1000km_plus: "距離1000公里以上",
    distance_100km_plus: "距離100公里以上",
    include: "包含",
    exclude: "排除",
    custom_date_range: "自訂日期範圍",
    examples: "範例",
    invalid_format: "無效格式。使用：數字（例如：30）、範圍（例如：0-7）或年齡格式（例如：age0-30）",
    generations: "世代",
    pokemon_groups: "寶可夢群組",
    gen_1_kanto: "第1世代（關都）",
    gen_2_johto: "第2世代（城都）",
    gen_3_hoenn: "第3世代（豐緣）",
    gen_4_sinnoh: "第4世代（神奧）",
    gen_5_unova: "第5世代（合眾）",
    gen_6_kalos: "第6世代（卡洛斯）",
    gen_7_alola: "第7世代（阿羅拉）",
    gen_8_galar: "第8世代（伽勒爾）",
    all_starters: "所有初始寶可夢",
    kanto_starters: "關都初始",
    johto_starters: "城都初始",
    hoenn_starters: "豐緣初始",
    sinnoh_starters: "神奧初始",
    unova_starters: "合眾初始",
    kalos_starters: "卡洛斯初始",
    alola_starters: "阿羅拉初始",
    galar_starters: "伽勒爾初始",
    pseudo_legendaries: "準傳說",
    eeveelutions: "伊布進化型",
    quick_combos: "快速組合",
    quick_combos_info: "這些按鈕會將篩選器組合添加到您現有的搜尋字串中，讓您可以將多個組合堆疊在一起。",
    shiny_legendaries: "色違傳說",
    shiny_legendaries_desc: "所有色違傳說寶可夢",
    perfect_shadows: "完美暗影",
    perfect_shadows_desc: "100%個體值暗影寶可夢",
    high_iv_non_shiny: "高個體值非色違",
    high_iv_non_shiny_desc: "非色違的3-4★寶可夢",
    trade_fodder: "交換用",
    trade_fodder_desc: "用於交換的低個體值非最愛",
    recent_catches: "最近捕獲",
    recent_catches_desc: "上週捕獲的寶可夢",
    evolution_ready: "進化就緒",
    evolution_ready_desc: "可以進化，非最愛",
    shiny_costume: "色違服裝",
    shiny_costume_desc: "帶服裝的色違寶可夢",
    legendary_non_shiny: "非色違傳說",
    legendary_non_shiny_desc: "您尚未找到色違的傳說",
    pvp_league_cp_caps: "PvP聯盟CP上限",
    pvp_league_cp_caps_desc: "這些是Pokémon GO中使用的競技PvP聯盟CP上限。點擊按鈕將在您的搜尋字串中插入或替換CP範圍。",
    great_league: "超級聯盟",
    great_league_cp: "CP 0-1500",
    ultra_league: "高級聯盟",
    ultra_league_cp: "CP 0-2500",
    master_league: "大師聯盟",
    master_league_cp: "CP 2500+",
    under_500_cp: "低於500 CP",
    under_500_cp_value: "CP 0-500",
    high_cp: "高CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "完美CP",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "對戰等級、PvP和常見組合",
    premade_pvp_competitive: "PvP與競技",
    premade_raid_attackers: "對戰等級攻擊者",
    premade_master_league: "PvP大師聯盟",
    premade_common_combos: "常見組合",
    info_shadow_vs_nonshadow_title: "暗影 vs 非暗影",
    info_shadow_vs_nonshadow_text: "Pokémon GO無法同時顯示暗影和非暗影版本。請使用單獨的搜尋。",
    info_master_league_title: "大師聯盟排名",
    info_master_league_text: "基於大師聯盟PvP競技對戰排名。包括頂級排名寶可夢，如蒼響（劍之王）、帕路奇亞（起源與暗影）、藏瑪然特（盾之王）、帝牙盧卡（起源與暗影）、酋雷姆（白與黑）、捷克羅姆、萊希拉姆、洛奇亞、巨金怪、無極汰那、奈克洛茲瑪、露奈雅拉、鳳王、固拉多、拉帝歐斯、美洛耶塔、花潔夫人、波克基斯和索爾迦雷歐。",
    tier_s_label: "S級",
    tier_s_description: "力量頂峰",
    tier_aplus_label: "A+級",
    tier_aplus_description: "位於或接近頂峰",
    tier_a_label: "A級",
    tier_a_description: "黃金標準投資",
    badge_shadow: "暗影",
    badge_mega: "超級",
    badge_mega_primal: "超級/原始",
    premade_s_tier_shadows: "S級暗影",
    premade_s_tier_shadows_desc: "暗影寶可夢 - 力量頂峰",
    premade_s_tier_nonshadow: "S級非暗影",
    premade_s_tier_nonshadow_desc: "超級/原始寶可夢 - 最高優先級",
    premade_aplus_tier_shadows: "A+級暗影",
    premade_aplus_tier_shadows_desc: "暗影寶可夢 - 位於或接近頂峰",
    premade_aplus_tier_nonshadow: "A+級非暗影",
    premade_aplus_tier_nonshadow_desc: "超級寶可夢 - 位於或接近頂峰",
    premade_a_tier_shadows: "A級暗影",
    premade_a_tier_shadows_desc: "暗影寶可夢 - 黃金標準投資價值",
    premade_a_tier_nonshadow: "A級非暗影",
    premade_a_tier_nonshadow_desc: "超級寶可夢 - 黃金標準投資價值",
    premade_top25_master_league: "前25大師聯盟",
    premade_top25_master_league_desc: "大師聯盟PvP競技對戰的頂級排名寶可夢",
    how_to_use_filter_buttons: "如何使用篩選器按鈕",
    operator_and_title: "AND",
    operator_and_symbol: "&",
    operator_and_description: "必須有此篩選器 - 與其他AND篩選器組合（例如：異色 AND 傳說只顯示異色傳說）",
    operator_or_title: "OR",
    operator_or_symbol: ",",
    operator_or_description: "可以是其中任何一個 - 顯示替代選項（例如：4★ OR 3★ 顯示所有3星和4星寶可夢）",
    operator_not_title: "NOT",
    operator_not_symbol: "!",
    operator_not_description: "排除此篩選器 - 隱藏匹配的寶可夢（例如：NOT 暗影排除所有暗影寶可夢）",
    operator_tip: "💡 提示：您可以組合運算符！試試「4★ AND 傳說 OR 幻 AND NOT 暗影」來找到不是暗影的完美個體值傳說/幻寶可夢。",
    validation_error_multiple_attack_ivs: "無法對多個攻擊個體值使用AND ({filters})",
    validation_error_multiple_attack_ivs_why: "寶可夢只能有一個攻擊個體值。您同時要求 {filters}。",
    validation_error_multiple_attack_ivs_fix: "改為OR：{filters} - 這將顯示具有這些攻擊值中任何一個的寶可夢。",
    validation_error_multiple_defense_ivs: "無法對多個防禦個體值使用AND ({filters})",
    validation_error_multiple_defense_ivs_why: "寶可夢只能有一個防禦個體值。您同時要求 {filters}。",
    validation_error_multiple_defense_ivs_fix: "改為OR：{filters} - 這將顯示具有這些防禦值中任何一個的寶可夢。",
    validation_error_multiple_hp_ivs: "無法對多個HP個體值使用AND ({filters})",
    validation_error_multiple_hp_ivs_why: "寶可夢只能有一個HP個體值。您同時要求 {filters}。",
    validation_error_multiple_hp_ivs_fix: "改為OR：{filters} - 這將顯示具有這些HP值中任何一個的寶可夢。",
    validation_error_multiple_star_ratings: "無法對多個星級使用AND ({filters})",
    validation_error_multiple_star_ratings_why: "寶可夢根據總個體值有一個星級。它不能同時是 {filters}。",
    validation_error_multiple_star_ratings_fix: "改為OR：{filters} - 這將顯示具有這些星級中任何一個的寶可夢。",
    validation_error_shadow_and_purified: "暗影 AND 淨化",
    validation_error_shadow_and_purified_why: "寶可夢不能同時是暗影和淨化。一旦淨化，它就不再是暗影。",
    validation_error_shadow_and_purified_fix: "改為OR：暗影,淨化 - 這將顯示是暗影或淨化的寶可夢。",
    validation_error_4star_with_nonperfect: "4★ 與非完美個體值 ({filters})",
    validation_error_4star_with_nonperfect_why: "4★ 表示15/15/15（所有完美能力值）。要求完美能力值時不能有 {nonperfect}。",
    validation_error_4star_with_nonperfect_fix: "移除4★，或移除 {filters}，或將4★改為OR如果您想要完美或非完美。",
    validation_error_perfect_stats_exclude_4star: "要求完美攻擊、防禦和HP但排除4★",
    validation_error_perfect_stats_exclude_4star_why: "15/15/15 就是4★（完美）寶可夢。您不能擁有所有完美能力值而不是4★。",
    validation_error_perfect_stats_exclude_4star_fix: "移除 NOT 4★，或移除其中一個完美能力值要求。",
    validation_error_0star_with_high_ivs: "0★ 與高個體值 ({filters})",
    validation_error_0star_with_high_ivs_why: "0★ 表示0-49%總個體值（0-22能力點）。像 {filters} 這樣的高個體值會將其推高於0★。",
    validation_error_0star_with_high_ivs_fix: "將0★改為更高的星級，或移除高個體值篩選器，或使用OR而不是AND。",
    validation_error_3star_with_zero_ivs: "3★ 與 {count} 個零個體值 ({filters})",
    validation_error_3star_with_zero_ivs_why: "3★ 需要37-44總能力點（82-98%）。有2+個能力值為0在數學上是不可能的。",
    validation_error_3star_with_zero_ivs_fix: "移除3★，或移除零個體值篩選器，或改為1★或0★。",
    validation_error_2star_with_zero_ivs: "2★ 與2+個零個體值 ({filters})",
    validation_error_2star_with_zero_ivs_why: "2★ 需要30-36總能力點。有2個能力值為0時，您需要第三個為30+，這是不可能的（最大值為15）。",
    validation_error_2star_with_zero_ivs_fix: "移除2★，或移除零個體值篩選器，或改為0★或1★。",
    validation_error_3star_with_all_perfect: "3★ 與所有完美個體值（4attack, 4defense, 4hp）",
    validation_error_3star_with_all_perfect_why: "3★ 表示82-98%總個體值（37-44能力點）。三個完美能力值 = 45點，這是4★（100%），不是3★。",
    validation_error_3star_with_all_perfect_fix: "將3★改為4★，或移除其中一個完美個體值要求。"
  },
  "Hindi": {
    app_title: "Pokémon GO खोज बिल्डर",
    app_subtitle: "खोज स्ट्रिंग्स को दृश्य रूप से बनाएं",
    search_string: "खोज स्ट्रिंग",
    search_placeholder: "आपकी खोज स्ट्रिंग यहाँ दिखाई देगी...",
    filter_search_placeholder: "फ़िल्टर खोजें... (उदा., 'shiny')",
    stats_ivs: "स्टैट्स और IVs",
    types: "प्रकार",
    special_status: "विशेष स्थिति",
    evolution_buddy: "विकास और बडी",
    time_distance: "समय और दूरी",
    size_gender: "आकार और लिंग",
    moves: "हमले",
    regions: "क्षेत्र",
    clear_all: "सभी साफ करें",
    copy: "कॉपी करें",
    copied: "कॉपी हो गया!",
    copy_has_issues: "कॉपी करें (समस्याएं हैं)",
    validation_error_title: "⚠️ यह खोज Pokémon GO में काम नहीं करेगी",
    validation_error_subtitle: "ये संयोजन असंभव हैं, लेकिन अगर आप प्रयोग करना चाहते हैं तो फिर भी कॉपी कर सकते हैं।",
    validation_why_label: "यह क्यों काम नहीं करेगा:",
    validation_fix_label: "✓ कैसे ठीक करें:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "परफेक्ट अटैक (15)",
    filter_3attack: "हाई अटैक (12-14)",
    filter_4defense: "परफेक्ट डिफेंस (15)",
    filter_3defense: "हाई डिफेंस (12-14)",
    filter_4hp: "परफेक्ट HP (15)",
    filter_3hp: "हाई HP (12-14)",
    filter_0attack: "जीरो अटैक",
    filter_0defense: "जीरो डिफेंस",
    filter_0hp: "जीरो HP",
    filter_shiny: "शाइनी",
    filter_lucky: "लकी",
    filter_shadow: "शैडो",
    filter_purified: "प्यूरिफाइड",
    filter_legendary: "लेजेंडरी",
    filter_mythical: "मिथिकल",
    save_this_search: "इस खोज को सहेजें",
    search_saved: "खोज सहेजी गई!",
    active: "सक्रिय",
    light_mode: "लाइट मोड",
    dark_mode: "डार्क मोड",
    translation_warnings: "अनुवाद चेतावनियाँ:",
    conflicting_filters: "संघर्ष करने वाले फ़िल्टर",
    remove_spaces: "खोज स्ट्रिंग से रिक्त स्थान हटाएं",
    missing_ampersand: "फ़िल्टर के बीच & गायब है",
    use_commas: "पोकीडेक्स नंबरों के बीच & के बजाय अल्पविराम का उपयोग करें",
    quick_searches: "त्वरित खोज",
    cp_ranges: "CP रेंज",
    pokemon_selection: "पोकेमॉन चयन",
    pokemon_groups: "पोकेमॉन समूह",
    insert_cp_range: "PvP लीग के लिए CP रेंज डालें",
    quick_insert_pokemon: "पोकेमॉन रेंज और समूह त्वरित डालें",
    saved_searches: "सहेजी गई खोज",
    import_searches: "खोज आयात करें",
    export_searches: "खोज निर्यात करें",
    delete_saved_search: "सहेजी गई खोज हटाएं",
    storage_limit_reached: "स्टोरेज सीमा पहुँच गई। कृपया कुछ सहेजी गई खोज हटाएं।",
    failed_import: "सहेजी गई खोज आयात करने में विफल। कृपया फ़ाइल प्रारूप जांचें।",
    language: "भाषा",
    language_wip: "(WIP)",
    join_discord: "अपडेट, सुझाव और बग रिपोर्ट के लिए Discord में शामिल हों",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "आज पकड़ा गया",
    last_7_days: "पिछले 7 दिन",
    last_30_days: "पिछले 30 दिन",
    last_week: "पिछला सप्ताह",
    last_month: "पिछला महीना",
    last_year: "पिछला साल",
    custom_age: "कस्टम उम्र",
    today: "आज",
    more_than_days_ago: "{days} दिन से अधिक पहले",
    days_ago: "{start}-{end} दिन पहले",
    last_days: "पिछले {days} दिन",
    age_label: "उम्र {value}",
    distance_1000km_plus: "दूरी 1000किमी+",
    distance_100km_plus: "दूरी 100किमी+",
    include: "शामिल करें",
    exclude: "बाहर करें",
    custom_date_range: "कस्टम तारीख सीमा",
    examples: "उदाहरण",
    invalid_format: "अमान्य प्रारूप। उपयोग करें: संख्या (उदा., 30), सीमा (उदा., 0-7), या उम्र प्रारूप (उदा., age0-30)",
    generations: "पीढ़ियाँ",
    pokemon_groups: "पोकेमॉन समूह",
    gen_1_kanto: "पीढ़ी 1 (कांटो)",
    gen_2_johto: "पीढ़ी 2 (जोहटो)",
    gen_3_hoenn: "पीढ़ी 3 (होएन)",
    gen_4_sinnoh: "पीढ़ी 4 (सिन्नोह)",
    gen_5_unova: "पीढ़ी 5 (यूनोवा)",
    gen_6_kalos: "पीढ़ी 6 (कालोस)",
    gen_7_alola: "पीढ़ी 7 (अलोला)",
    gen_8_galar: "पीढ़ी 8 (गैलर)",
    all_starters: "सभी स्टार्टर",
    kanto_starters: "कांटो स्टार्टर",
    johto_starters: "जोहटो स्टार्टर",
    hoenn_starters: "होएन स्टार्टर",
    sinnoh_starters: "सिन्नोह स्टार्टर",
    unova_starters: "यूनोवा स्टार्टर",
    kalos_starters: "कालोस स्टार्टर",
    alola_starters: "अलोला स्टार्टर",
    galar_starters: "गैलर स्टार्टर",
    pseudo_legendaries: "छद्म-पौराणिक",
    eeveelutions: "ईवी विकास",
    quick_combos: "त्वरित कॉम्बो",
    quick_combos_info: "ये बटन आपकी मौजूदा खोज स्ट्रिंग में फ़िल्टर संयोजन जोड़ते हैं, जिससे आप कई कॉम्बो को एक साथ स्टैक कर सकते हैं।",
    shiny_legendaries: "चमकदार पौराणिक",
    shiny_legendaries_desc: "सभी चमकदार पौराणिक पोकेमॉन",
    perfect_shadows: "परफेक्ट शैडो",
    perfect_shadows_desc: "100% IV शैडो पोकेमॉन",
    high_iv_non_shiny: "उच्च IV गैर-चमकदार",
    high_iv_non_shiny_desc: "3-4★ पोकेमॉन जो चमकदार नहीं हैं",
    trade_fodder: "ट्रेड सामग्री",
    trade_fodder_desc: "ट्रेडिंग के लिए कम IV गैर-पसंदीदा",
    recent_catches: "हाल की पकड़",
    recent_catches_desc: "पिछले सप्ताह पकड़े गए पोकेमॉन",
    evolution_ready: "विकास तैयार",
    evolution_ready_desc: "विकसित हो सकता है, पसंदीदा नहीं",
    shiny_costume: "चमकदार कॉस्ट्यूम",
    shiny_costume_desc: "कॉस्ट्यूम के साथ चमकदार पोकेमॉन",
    legendary_non_shiny: "पौराणिक गैर-चमकदार",
    legendary_non_shiny_desc: "पौराणिक जिन्हें आपने अभी तक चमकदार नहीं पाया",
    pvp_league_cp_caps: "PvP लीग CP सीमाएं",
    pvp_league_cp_caps_desc: "ये Pokémon GO में उपयोग की जाने वाली प्रतिस्पर्धी PvP लीग CP सीमाएं हैं। एक बटन पर क्लिक करने से आपकी खोज स्ट्रिंग में CP रेंज डाली या प्रतिस्थापित की जाएगी।",
    great_league: "ग्रेट लीग",
    great_league_cp: "CP 0-1500",
    ultra_league: "अल्ट्रा लीग",
    ultra_league_cp: "CP 0-2500",
    master_league: "मास्टर लीग",
    master_league_cp: "CP 2500+",
    under_500_cp: "500 CP से कम",
    under_500_cp_value: "CP 0-500",
    high_cp: "उच्च CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "परफेक्ट CP",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "रेड स्तर, PvP और सामान्य कॉम्बो",
    premade_pvp_competitive: "PvP और प्रतिस्पर्धी",
    premade_raid_attackers: "रेड स्तर अटैकर्स",
    premade_master_league: "PvP मास्टर लीग",
    premade_common_combos: "सामान्य कॉम्बो",
    info_shadow_vs_nonshadow_title: "शैडो vs नॉन-शैडो",
    info_shadow_vs_nonshadow_text: "Pokémon GO शैडो और नॉन-शैडो संस्करणों को एक साथ प्रदर्शित नहीं कर सकता। अलग-अलग खोजें उपयोग करें।",
    info_master_league_title: "मास्टर लीग रैंकिंग",
    info_master_league_text: "प्रतिस्पर्धी लड़ाई के लिए मास्टर लीग PvP रैंकिंग पर आधारित। जैसियन (क्राउन्ड स्वॉर्ड), पाल्किया (ओरिजिन और शैडो), ज़ामाज़ेंटा (क्राउन्ड शील्ड), डायलगा (ओरिजिन और शैडो), क्यूरेम (व्हाइट और ब्लैक), ज़ेक्रोम, रेशिरम, लुगिया, मेटाग्रॉस, एटर्नाटस, नेक्रोज़मा, लुनाला, हो-ओह, ग्राउडन, लैटियोस, मेलोएटा, फ्लोर्जेस, टोगेकिस और सोलगालेओ जैसे शीर्ष-रैंक वाले पोकेमॉन शामिल हैं।",
    tier_s_label: "S-स्तर",
    tier_s_description: "शक्ति का शिखर",
    tier_aplus_label: "A+-स्तर",
    tier_aplus_description: "शीर्ष पर या उसके पास खड़े",
    tier_a_label: "A-स्तर",
    tier_a_description: "गोल्ड स्टैंडर्ड निवेश",
    badge_shadow: "शैडो",
    badge_mega: "मेगा",
    badge_mega_primal: "मेगा/प्राइमल",
    premade_s_tier_shadows: "S-स्तर शैडो",
    premade_s_tier_shadows_desc: "शैडो पोकेमॉन - शक्ति का शिखर",
    premade_s_tier_nonshadow: "S-स्तर नॉन-शैडो",
    premade_s_tier_nonshadow_desc: "मेगा/प्राइमल पोकेमॉन - उच्चतम प्राथमिकताएं",
    premade_aplus_tier_shadows: "A+-स्तर शैडो",
    premade_aplus_tier_shadows_desc: "शैडो पोकेमॉन - शीर्ष पर या उसके पास खड़े",
    premade_aplus_tier_nonshadow: "A+-स्तर नॉन-शैडो",
    premade_aplus_tier_nonshadow_desc: "मेगा पोकेमॉन - शीर्ष पर या उसके पास खड़े",
    premade_a_tier_shadows: "A-स्तर शैडो",
    premade_a_tier_shadows_desc: "शैडो पोकेमॉन - गोल्ड स्टैंडर्ड निवेश योग्य",
    premade_a_tier_nonshadow: "A-स्तर नॉन-शैडो",
    premade_a_tier_nonshadow_desc: "मेगा पोकेमॉन - गोल्ड स्टैंडर्ड निवेश योग्य",
    premade_top25_master_league: "टॉप 25 मास्टर लीग",
    premade_top25_master_league_desc: "मास्टर लीग PvP प्रतिस्पर्धी लड़ाई के लिए शीर्ष-रैंक वाले पोकेमॉन"
  },
  "Indonesian": {
    app_title: "Pembangun Pencarian Pokémon GO",
    app_subtitle: "Buat string pencarian secara visual",
    search_string: "String Pencarian",
    search_placeholder: "String pencarian Anda akan muncul di sini...",
    filter_search_placeholder: "Cari filter... (mis., 'shiny')",
    stats_ivs: "Statistik & IV",
    types: "Tipe",
    special_status: "Status Khusus",
    evolution_buddy: "Evolusi & Teman",
    time_distance: "Waktu & Jarak",
    size_gender: "Ukuran & Jenis Kelamin",
    moves: "Gerakan",
    regions: "Wilayah",
    clear_all: "Hapus Semua",
    copy: "Salin",
    copied: "Disalin!",
    copy_has_issues: "Salin (Ada Masalah)",
    validation_error_title: "⚠️ Pencarian ini tidak akan berfungsi di Pokémon GO",
    validation_error_subtitle: "Kombinasi ini tidak mungkin, tetapi Anda masih bisa menyalin jika ingin bereksperimen.",
    validation_why_label: "Mengapa tidak akan berfungsi:",
    validation_fix_label: "✓ Cara memperbaiki:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "Serangan Sempurna (15)",
    filter_3attack: "Serangan Tinggi (12-14)",
    filter_4defense: "Pertahanan Sempurna (15)",
    filter_3defense: "Pertahanan Tinggi (12-14)",
    filter_4hp: "HP Sempurna (15)",
    filter_3hp: "HP Tinggi (12-14)",
    filter_0attack: "Serangan Nol",
    filter_0defense: "Pertahanan Nol",
    filter_0hp: "HP Nol",
    filter_shiny: "Berkilau",
    filter_lucky: "Beruntung",
    filter_shadow: "Bayangan",
    filter_purified: "Dimurnikan",
    filter_legendary: "Legendaris",
    filter_mythical: "Mistik",
    save_this_search: "Simpan pencarian ini",
    search_saved: "Pencarian disimpan!",
    active: "aktif",
    light_mode: "Mode terang",
    dark_mode: "Mode gelap",
    translation_warnings: "Peringatan Terjemahan:",
    conflicting_filters: "Filter yang Berkonflik",
    remove_spaces: "Hapus spasi dari string pencarian",
    missing_ampersand: "& hilang di antara filter",
    use_commas: "Gunakan koma di antara nomor Pokédex, bukan &",
    quick_searches: "Pencarian Cepat",
    cp_ranges: "Rentang CP",
    pokemon_selection: "Pemilihan Pokémon",
    pokemon_groups: "Grup Pokémon",
    insert_cp_range: "Sisipkan rentang CP untuk liga PvP",
    quick_insert_pokemon: "Sisipkan cepat rentang dan grup Pokémon",
    saved_searches: "Pencarian Tersimpan",
    import_searches: "Impor pencarian",
    export_searches: "Ekspor pencarian",
    delete_saved_search: "Hapus pencarian tersimpan",
    storage_limit_reached: "Batas penyimpanan tercapai. Hapus beberapa pencarian tersimpan.",
    failed_import: "Gagal mengimpor pencarian tersimpan. Periksa format file.",
    language: "Bahasa",
    language_wip: "(WIP)",
    join_discord: "Bergabunglah dengan Discord untuk pembaruan, saran, dan laporan bug",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Ditangkap Hari Ini",
    last_7_days: "7 Hari Terakhir",
    last_30_days: "30 Hari Terakhir",
    last_week: "Minggu Lalu",
    last_month: "Bulan Lalu",
    last_year: "Tahun Lalu",
    custom_age: "Usia Kustom",
    today: "Hari Ini",
    more_than_days_ago: "Lebih dari {days} hari yang lalu",
    days_ago: "{start}-{end} hari yang lalu",
    last_days: "{days} Hari Terakhir",
    age_label: "Usia {value}",
    distance_1000km_plus: "Jarak 1000km+",
    distance_100km_plus: "Jarak 100km+",
    include: "Sertakan",
    exclude: "Kecualikan",
    custom_date_range: "Rentang Tanggal Kustom",
    examples: "Contoh",
    invalid_format: "Format tidak valid. Gunakan: angka (mis., 30), rentang (mis., 0-7), atau format usia (mis., age0-30)",
    generations: "Generasi",
    pokemon_groups: "Grup Pokémon",
    gen_1_kanto: "Gen 1 (Kanto)",
    gen_2_johto: "Gen 2 (Johto)",
    gen_3_hoenn: "Gen 3 (Hoenn)",
    gen_4_sinnoh: "Gen 4 (Sinnoh)",
    gen_5_unova: "Gen 5 (Unova)",
    gen_6_kalos: "Gen 6 (Kalos)",
    gen_7_alola: "Gen 7 (Alola)",
    gen_8_galar: "Gen 8 (Galar)",
    all_starters: "Semua Starter",
    kanto_starters: "Starter Kanto",
    johto_starters: "Starter Johto",
    hoenn_starters: "Starter Hoenn",
    sinnoh_starters: "Starter Sinnoh",
    unova_starters: "Starter Unova",
    kalos_starters: "Starter Kalos",
    alola_starters: "Starter Alola",
    galar_starters: "Starter Galar",
    pseudo_legendaries: "Pseudo-Legendari",
    eeveelutions: "Evolusi Eevee",
    quick_combos: "Kombinasi Cepat",
    quick_combos_info: "Tombol-tombol ini menambahkan kombinasi filter ke string pencarian Anda yang ada, memungkinkan Anda menumpuk beberapa kombinasi bersama.",
    shiny_legendaries: "Legendari Berkilau",
    shiny_legendaries_desc: "Semua Pokémon legendari berkilau",
    perfect_shadows: "Bayangan Sempurna",
    perfect_shadows_desc: "Pokémon bayangan dengan IV 100%",
    high_iv_non_shiny: "IV Tinggi Non-Berkilau",
    high_iv_non_shiny_desc: "Pokémon 3-4★ yang tidak berkilau",
    trade_fodder: "Bahan Tukar",
    trade_fodder_desc: "IV rendah non-favorit untuk ditukar",
    recent_catches: "Tangkapan Terkini",
    recent_catches_desc: "Pokémon yang ditangkap minggu lalu",
    evolution_ready: "Siap Berevolusi",
    evolution_ready_desc: "Bisa berevolusi, tidak favorit",
    shiny_costume: "Kostum Berkilau",
    shiny_costume_desc: "Pokémon berkilau dengan kostum",
    legendary_non_shiny: "Legendari Non-Berkilau",
    legendary_non_shiny_desc: "Legendari yang belum Anda temukan berkilau",
    pvp_league_cp_caps: "Batas CP Liga PvP",
    pvp_league_cp_caps_desc: "Ini adalah batas CP kompetitif liga PvP yang digunakan di Pokémon GO. Mengklik tombol akan menyisipkan atau mengganti rentang CP dalam string pencarian Anda.",
    great_league: "Liga Super",
    great_league_cp: "CP 0-1500",
    ultra_league: "Liga Ultra",
    ultra_league_cp: "CP 0-2500",
    master_league: "Liga Master",
    master_league_cp: "CP 2500+",
    under_500_cp: "Di Bawah 500 CP",
    under_500_cp_value: "CP 0-500",
    high_cp: "CP Tinggi",
    high_cp_value: "CP 3000+",
    perfect_cp: "CP Sempurna",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "Tingkat raid, PvP, dan kombinasi umum",
    premade_pvp_competitive: "PvP & Kompetitif",
    premade_raid_attackers: "Penyerang Tingkat Raid",
    premade_master_league: "PvP Liga Master",
    premade_common_combos: "Kombinasi Umum",
    info_shadow_vs_nonshadow_title: "Shadow vs Non-Shadow",
    info_shadow_vs_nonshadow_text: "Pokémon GO tidak dapat menampilkan versi Shadow dan non-Shadow secara bersamaan. Gunakan pencarian terpisah.",
    info_master_league_title: "Peringkat Liga Master",
    info_master_league_text: "Berdasarkan peringkat PvP Liga Master untuk pertempuran kompetitif. Termasuk Pokemon peringkat teratas seperti Zacian (Crowned Sword), Palkia (Origin & Shadow), Zamazenta (Crowned Shield), Dialga (Origin & Shadow), Kyurem (White & Black), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss, dan Solgaleo.",
    tier_s_label: "Tingkat S",
    tier_s_description: "Puncak Kekuatan",
    tier_aplus_label: "Tingkat A+",
    tier_aplus_description: "Berdiri di atau Dekat Puncak",
    tier_a_label: "Tingkat A",
    tier_a_description: "Investasi Standar Emas",
    badge_shadow: "BAYANGAN",
    badge_mega: "MEGA",
    badge_mega_primal: "MEGA/PRIMAL",
    premade_s_tier_shadows: "Shadow Tingkat S",
    premade_s_tier_shadows_desc: "Pokemon Shadow - puncak kekuatan",
    premade_s_tier_nonshadow: "Non-Shadow Tingkat S",
    premade_s_tier_nonshadow_desc: "Pokemon Mega/Primal - prioritas tertinggi",
    premade_aplus_tier_shadows: "Shadow Tingkat A+",
    premade_aplus_tier_shadows_desc: "Pokemon Shadow - berdiri di atau dekat puncak",
    premade_aplus_tier_nonshadow: "Non-Shadow Tingkat A+",
    premade_aplus_tier_nonshadow_desc: "Pokemon Mega - berdiri di atau dekat puncak",
    premade_a_tier_shadows: "Shadow Tingkat A",
    premade_a_tier_shadows_desc: "Pokemon Shadow - standar emas layak investasi",
    premade_a_tier_nonshadow: "Non-Shadow Tingkat A",
    premade_a_tier_nonshadow_desc: "Pokemon Mega - standar emas layak investasi",
    premade_top25_master_league: "Top 25 Liga Master",
    premade_top25_master_league_desc: "Pokemon peringkat teratas untuk pertempuran kompetitif PvP Liga Master"
  },
  "Thai": {
    app_title: "ตัวสร้างสตริงค้นหา Pokémon GO",
    app_subtitle: "สร้างสตริงค้นหาแบบภาพ",
    search_string: "สตริงค้นหา",
    search_placeholder: "สตริงค้นหาของคุณจะปรากฏที่นี่...",
    filter_search_placeholder: "ค้นหาฟิลเตอร์... (เช่น 'shiny')",
    stats_ivs: "ค่าสถานะและ IV",
    types: "ประเภท",
    special_status: "สถานะพิเศษ",
    evolution_buddy: "วิวัฒนาการและบัดดี้",
    time_distance: "เวลาและระยะทาง",
    size_gender: "ขนาดและเพศ",
    moves: "ท่าต่อสู้",
    regions: "ภูมิภาค",
    clear_all: "ล้างทั้งหมด",
    copy: "คัดลอก",
    copied: "คัดลอกแล้ว!",
    copy_has_issues: "คัดลอก (มีปัญหา)",
    validation_error_title: "⚠️ การค้นหานี้ใช้ไม่ได้ใน Pokémon GO",
    validation_error_subtitle: "การผสมเหล่านี้เป็นไปไม่ได้ แต่คุณยังคัดลอกได้หากต้องการทดลอง",
    validation_why_label: "ทำไมมันถึงใช้ไม่ได้:",
    validation_fix_label: "✓ วิธีแก้ไข:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "โจมตีสมบูรณ์แบบ (15)",
    filter_3attack: "โจมตีสูง (12-14)",
    filter_4defense: "ป้องกันสมบูรณ์แบบ (15)",
    filter_3defense: "ป้องกันสูง (12-14)",
    filter_4hp: "HP สมบูรณ์แบบ (15)",
    filter_3hp: "HP สูง (12-14)",
    filter_0attack: "โจมตีศูนย์",
    filter_0defense: "ป้องกันศูนย์",
    filter_0hp: "HP ศูนย์",
    filter_shiny: "เงา",
    filter_lucky: "โชคดี",
    filter_shadow: "เงา",
    filter_purified: "ชำระแล้ว",
    filter_legendary: "ตำนาน",
    filter_mythical: "ตำนาน",
    save_this_search: "บันทึกการค้นหานี้",
    search_saved: "บันทึกการค้นหาแล้ว!",
    active: "ใช้งาน",
    light_mode: "โหมดสว่าง",
    dark_mode: "โหมดมืด",
    translation_warnings: "คำเตือนการแปล:",
    conflicting_filters: "ฟิลเตอร์ที่ขัดแย้ง",
    remove_spaces: "ลบช่องว่างออกจากสตริงค้นหา",
    missing_ampersand: "ขาด & ระหว่างฟิลเตอร์",
    use_commas: "ใช้เครื่องหมายจุลภาคระหว่างหมายเลขโปเกมอน ไม่ใช่ &",
    quick_searches: "การค้นหาแบบด่วน",
    cp_ranges: "ช่วง CP",
    pokemon_selection: "การเลือกโปเกมอน",
    pokemon_groups: "กลุ่มโปเกมอน",
    insert_cp_range: "แทรกช่วง CP สำหรับลีก PvP",
    quick_insert_pokemon: "แทรกช่วงและกลุ่มโปเกมอนแบบด่วน",
    saved_searches: "การค้นหาที่บันทึกไว้",
    import_searches: "นำเข้าการค้นหา",
    export_searches: "ส่งออกการค้นหา",
    delete_saved_search: "ลบการค้นหาที่บันทึกไว้",
    storage_limit_reached: "ถึงขีดจำกัดการจัดเก็บแล้ว กรุณาลบการค้นหาที่บันทึกไว้บางส่วน",
    failed_import: "นำเข้าการค้นหาที่บันทึกไว้ล้มเหลว กรุณาตรวจสอบรูปแบบไฟล์",
    language: "ภาษา",
    language_wip: "(WIP)",
    join_discord: "เข้าร่วม Discord เพื่อรับอัปเดต คำแนะนำ และรายงานข้อผิดพลาด",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "จับวันนี้",
    last_7_days: "7 วันที่ผ่านมา",
    last_30_days: "30 วันที่ผ่านมา",
    last_week: "สัปดาห์ที่แล้ว",
    last_month: "เดือนที่แล้ว",
    last_year: "ปีที่แล้ว",
    custom_age: "อายุที่กำหนดเอง",
    today: "วันนี้",
    more_than_days_ago: "มากกว่า {days} วันที่แล้ว",
    days_ago: "{start}-{end} วันที่แล้ว",
    last_days: "{days} วันที่ผ่านมา",
    age_label: "อายุ {value}",
    distance_1000km_plus: "ระยะทาง 1000กม.+",
    distance_100km_plus: "ระยะทาง 100กม.+",
    include: "รวม",
    exclude: "ยกเว้น",
    custom_date_range: "ช่วงวันที่ที่กำหนดเอง",
    examples: "ตัวอย่าง",
    invalid_format: "รูปแบบไม่ถูกต้อง ใช้: ตัวเลข (เช่น 30), ช่วง (เช่น 0-7), หรือรูปแบบอายุ (เช่น age0-30)",
    generations: "รุ่น",
    pokemon_groups: "กลุ่มโปเกมอน",
    gen_1_kanto: "รุ่นที่ 1 (คันโต)",
    gen_2_johto: "รุ่นที่ 2 (โจโตะ)",
    gen_3_hoenn: "รุ่นที่ 3 (โฮเอ็น)",
    gen_4_sinnoh: "รุ่นที่ 4 (ชินโน)",
    gen_5_unova: "รุ่นที่ 5 (อูโนวา)",
    gen_6_kalos: "รุ่นที่ 6 (คาลอส)",
    gen_7_alola: "รุ่นที่ 7 (อโลลา)",
    gen_8_galar: "รุ่นที่ 8 (กาลาร์)",
    all_starters: "สตาร์ทเตอร์ทั้งหมด",
    kanto_starters: "สตาร์ทเตอร์คันโต",
    johto_starters: "สตาร์ทเตอร์โจโตะ",
    hoenn_starters: "สตาร์ทเตอร์โฮเอ็น",
    sinnoh_starters: "สตาร์ทเตอร์ชินโน",
    unova_starters: "สตาร์ทเตอร์อูโนวา",
    kalos_starters: "สตาร์ทเตอร์คาลอส",
    alola_starters: "สตาร์ทเตอร์อโลลา",
    galar_starters: "สตาร์ทเตอร์กาลาร์",
    pseudo_legendaries: "กึ่งตำนาน",
    eeveelutions: "วิวัฒนาการอีวุย",
    quick_combos: "คอมโบด่วน",
    quick_combos_info: "ปุ่มเหล่านี้จะเพิ่มการรวมตัวของตัวกรองไปยังสตริงค้นหาที่มีอยู่ของคุณ ช่วยให้คุณสามารถซ้อนคอมโบหลายๆ ตัวเข้าด้วยกันได้",
    shiny_legendaries: "ตำนานเงา",
    shiny_legendaries_desc: "โปเกมอนตำนานเงาทั้งหมด",
    perfect_shadows: "เงาสมบูรณ์แบบ",
    perfect_shadows_desc: "โปเกมอนเงาที่มี IV 100%",
    high_iv_non_shiny: "IV สูงไม่เงา",
    high_iv_non_shiny_desc: "โปเกมอน 3-4★ ที่ไม่เงา",
    trade_fodder: "วัสดุแลกเปลี่ยน",
    trade_fodder_desc: "IV ต่ำไม่โปรดสำหรับแลกเปลี่ยน",
    recent_catches: "จับล่าสุด",
    recent_catches_desc: "โปเกมอนที่จับเมื่อสัปดาห์ที่แล้ว",
    evolution_ready: "พร้อมวิวัฒนาการ",
    evolution_ready_desc: "สามารถวิวัฒนาการได้ ไม่โปรด",
    shiny_costume: "ชุดเงา",
    shiny_costume_desc: "โปเกมอนเงาที่มีชุด",
    legendary_non_shiny: "ตำนานไม่เงา",
    legendary_non_shiny_desc: "ตำนานที่คุณยังไม่พบเงา",
    pvp_league_cp_caps: "ขีดจำกัด CP ลีก PvP",
    pvp_league_cp_caps_desc: "นี่คือขีดจำกัด CP แข่งขันของลีก PvP ที่ใช้ใน Pokémon GO การคลิกปุ่มจะแทรกหรือแทนที่ช่วง CP ในสตริงค้นหาของคุณ",
    great_league: "ลีกซูเปอร์",
    great_league_cp: "CP 0-1500",
    ultra_league: "ลีกอัลตรา",
    ultra_league_cp: "CP 0-2500",
    master_league: "ลีกมาสเตอร์",
    master_league_cp: "CP 2500+",
    under_500_cp: "ต่ำกว่า 500 CP",
    under_500_cp_value: "CP 0-500",
    high_cp: "CP สูง",
    high_cp_value: "CP 3000+",
    perfect_cp: "CP สมบูรณ์แบบ",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "ระดับเรด, PvP และคอมโบทั่วไป",
    premade_pvp_competitive: "PvP และการแข่งขัน",
    premade_raid_attackers: "ผู้โจมตีระดับเรด",
    premade_master_league: "PvP ลีกมาสเตอร์",
    premade_common_combos: "คอมโบทั่วไป",
    info_shadow_vs_nonshadow_title: "เงา vs ไม่ใช่เงา",
    info_shadow_vs_nonshadow_text: "Pokémon GO ไม่สามารถแสดงเวอร์ชันเงาและไม่ใช่เงาพร้อมกันได้ ใช้การค้นหาแยกกัน",
    info_master_league_title: "อันดับลีกมาสเตอร์",
    info_master_league_text: "อิงตามอันดับ PvP ลีกมาสเตอร์สำหรับการต่อสู้แบบแข่งขัน รวมถึงโปเกมอนอันดับต้นๆ เช่น Zacian (Crowned Sword), Palkia (Origin & Shadow), Zamazenta (Crowned Shield), Dialga (Origin & Shadow), Kyurem (White & Black), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss และ Solgaleo",
    tier_s_label: "ระดับ S",
    tier_s_description: "จุดสูงสุดของพลัง",
    tier_aplus_label: "ระดับ A+",
    tier_aplus_description: "ยืนอยู่ที่หรือใกล้จุดสูงสุด",
    tier_a_label: "ระดับ A",
    tier_a_description: "การลงทุนมาตรฐานทองคำ",
    badge_shadow: "เงา",
    badge_mega: "เมก้า",
    badge_mega_primal: "เมก้า/ปฐมภูมิ",
    premade_s_tier_shadows: "เงาระดับ S",
    premade_s_tier_shadows_desc: "โปเกมอนเงา - จุดสูงสุดของพลัง",
    premade_s_tier_nonshadow: "ไม่ใช่เงาระดับ S",
    premade_s_tier_nonshadow_desc: "โปเกมอนเมก้า/ไพรมัล - ลำดับความสำคัญสูงสุด",
    premade_aplus_tier_shadows: "เงาระดับ A+",
    premade_aplus_tier_shadows_desc: "โปเกมอนเงา - ยืนอยู่ที่หรือใกล้จุดสูงสุด",
    premade_aplus_tier_nonshadow: "ไม่ใช่เงาระดับ A+",
    premade_aplus_tier_nonshadow_desc: "โปเกมอนเมก้า - ยืนอยู่ที่หรือใกล้จุดสูงสุด",
    premade_a_tier_shadows: "เงาระดับ A",
    premade_a_tier_shadows_desc: "โปเกมอนเงา - มาตรฐานทองคำคุ้มค่าการลงทุน",
    premade_a_tier_nonshadow: "ไม่ใช่เงาระดับ A",
    premade_a_tier_nonshadow_desc: "โปเกมอนเมก้า - มาตรฐานทองคำคุ้มค่าการลงทุน",
    premade_top25_master_league: "Top 25 ลีกมาสเตอร์",
    premade_top25_master_league_desc: "โปเกมอนอันดับต้นๆ สำหรับการต่อสู้แบบแข่งขัน PvP ลีกมาสเตอร์"
  },
  "Turkish": {
    app_title: "Pokémon GO Arama Oluşturucu",
    app_subtitle: "Arama dizilerini görsel olarak oluşturun",
    search_string: "Arama Dizisi",
    search_placeholder: "Arama diziniz burada görünecek...",
    filter_search_placeholder: "Filtre ara... (örn., 'shiny')",
    stats_ivs: "İstatistikler ve IV",
    types: "Türler",
    special_status: "Özel Durum",
    evolution_buddy: "Evolüsyon ve Arkadaş",
    time_distance: "Zaman ve Mesafe",
    size_gender: "Boyut ve Cinsiyet",
    moves: "Hareketler",
    regions: "Bölgeler",
    clear_all: "Tümünü Temizle",
    copy: "Kopyala",
    copied: "Kopyalandı!",
    copy_has_issues: "Kopyala (Sorunlar Var)",
    validation_error_title: "⚠️ Bu arama Pokémon GO'da çalışmayacak",
    validation_error_subtitle: "Bu kombinasyonlar imkansız, ancak denemek isterseniz yine de kopyalayabilirsiniz.",
    validation_why_label: "Neden çalışmayacak:",
    validation_fix_label: "✓ Nasıl düzeltilir:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "Mükemmel Saldırı (15)",
    filter_3attack: "Yüksek Saldırı (12-14)",
    filter_4defense: "Mükemmel Savunma (15)",
    filter_3defense: "Yüksek Savunma (12-14)",
    filter_4hp: "Mükemmel HP (15)",
    filter_3hp: "Yüksek HP (12-14)",
    filter_0attack: "Sıfır Saldırı",
    filter_0defense: "Sıfır Savunma",
    filter_0hp: "Sıfır HP",
    filter_shiny: "Parlak",
    filter_lucky: "Şanslı",
    filter_shadow: "Gölge",
    filter_purified: "Arındırılmış",
    filter_legendary: "Efsanevi",
    filter_mythical: "Mitik",
    save_this_search: "Bu aramayı kaydet",
    search_saved: "Arama kaydedildi!",
    active: "aktif",
    light_mode: "Açık mod",
    dark_mode: "Koyu mod",
    translation_warnings: "Çeviri Uyarıları:",
    conflicting_filters: "Çakışan Filtreler",
    remove_spaces: "Arama dizisinden boşlukları kaldır",
    missing_ampersand: "Filtreler arasında & eksik",
    use_commas: "Pokédex numaraları arasında & yerine virgül kullanın",
    quick_searches: "Hızlı Aramalar",
    cp_ranges: "CP Aralıkları",
    pokemon_selection: "Pokémon Seçimi",
    pokemon_groups: "Pokémon Grupları",
    insert_cp_range: "PvP ligleri için CP aralıkları ekle",
    quick_insert_pokemon: "Pokémon aralıkları ve gruplarını hızlı ekle",
    saved_searches: "Kaydedilen Aramalar",
    import_searches: "Aramaları içe aktar",
    export_searches: "Aramaları dışa aktar",
    delete_saved_search: "Kaydedilen aramayı sil",
    storage_limit_reached: "Depolama sınırına ulaşıldı. Lütfen bazı kaydedilen aramaları silin.",
    failed_import: "Kaydedilen aramaları içe aktarma başarısız. Lütfen dosya formatını kontrol edin.",
    language: "Dil",
    language_wip: "(WIP)",
    join_discord: "Güncellemeler, öneriler ve hata raporları için Discord'a katılın",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Bugün Yakalandı",
    last_7_days: "Son 7 Gün",
    last_30_days: "Son 30 Gün",
    last_week: "Geçen Hafta",
    last_month: "Geçen Ay",
    last_year: "Geçen Yıl",
    custom_age: "Özel Yaş",
    today: "Bugün",
    more_than_days_ago: "{days} günden fazla önce",
    days_ago: "{start}-{end} gün önce",
    last_days: "Son {days} gün",
    age_label: "Yaş {value}",
    distance_1000km_plus: "Mesafe 1000km+",
    distance_100km_plus: "Mesafe 100km+",
    include: "Dahil Et",
    exclude: "Hariç Tut",
    custom_date_range: "Özel Tarih Aralığı",
    examples: "Örnekler",
    invalid_format: "Geçersiz format. Kullanın: sayı (örn., 30), aralık (örn., 0-7) veya yaş formatı (örn., age0-30)",
    generations: "Nesiller",
    pokemon_groups: "Pokémon Grupları",
    gen_1_kanto: "Nesil 1 (Kanto)",
    gen_2_johto: "Nesil 2 (Johto)",
    gen_3_hoenn: "Nesil 3 (Hoenn)",
    gen_4_sinnoh: "Nesil 4 (Sinnoh)",
    gen_5_unova: "Nesil 5 (Unova)",
    gen_6_kalos: "Nesil 6 (Kalos)",
    gen_7_alola: "Nesil 7 (Alola)",
    gen_8_galar: "Nesil 8 (Galar)",
    all_starters: "Tüm Başlangıçlar",
    kanto_starters: "Kanto Başlangıçları",
    johto_starters: "Johto Başlangıçları",
    hoenn_starters: "Hoenn Başlangıçları",
    sinnoh_starters: "Sinnoh Başlangıçları",
    unova_starters: "Unova Başlangıçları",
    kalos_starters: "Kalos Başlangıçları",
    alola_starters: "Alola Başlangıçları",
    galar_starters: "Galar Başlangıçları",
    pseudo_legendaries: "Yarı-Efsanevi",
    eeveelutions: "Eevee Evrimleri",
    quick_combos: "Hızlı Kombinasyonlar",
    quick_combos_info: "Bu düğmeler mevcut arama dizinize filtre kombinasyonları ekler ve birden fazla kombinasyonu birlikte yığmanıza olanak tanır.",
    shiny_legendaries: "Parıldayan Efsanevi",
    shiny_legendaries_desc: "Tüm parıldayan efsanevi Pokémon",
    perfect_shadows: "Mükemmel Gölgeler",
    perfect_shadows_desc: "%100 IV gölge Pokémon",
    high_iv_non_shiny: "Yüksek IV Parıldamayan",
    high_iv_non_shiny_desc: "Parıldamayan 3-4★ Pokémon",
    trade_fodder: "Takas Malzemesi",
    trade_fodder_desc: "Takas için düşük IV favori olmayan",
    recent_catches: "Son Yakalamalar",
    recent_catches_desc: "Geçen hafta yakalanan Pokémon",
    evolution_ready: "Evrim Hazır",
    evolution_ready_desc: "Evrilebilir, favori değil",
    shiny_costume: "Parıldayan Kostüm",
    shiny_costume_desc: "Kostümlü parıldayan Pokémon",
    legendary_non_shiny: "Efsanevi Parıldamayan",
    legendary_non_shiny_desc: "Henüz parıldayanını bulamadığınız efsanevi",
    pvp_league_cp_caps: "PvP Lig CP Sınırları",
    pvp_league_cp_caps_desc: "Bunlar Pokémon GO'da kullanılan rekabetçi PvP lig CP sınırlarıdır. Bir düğmeye tıklamak, arama dizinizdeki CP aralığını ekleyecek veya değiştirecektir.",
    great_league: "Süper Lig",
    great_league_cp: "CP 0-1500",
    ultra_league: "Ultra Lig",
    ultra_league_cp: "CP 0-2500",
    master_league: "Usta Lig",
    master_league_cp: "CP 2500+",
    under_500_cp: "500 CP Altı",
    under_500_cp_value: "CP 0-500",
    high_cp: "Yüksek CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "Mükemmel CP",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "Raid seviyeleri, PvP ve yaygın kombolar",
    premade_pvp_competitive: "PvP ve Rekabetçi",
    premade_raid_attackers: "Raid Seviyesi Saldırganlar",
    premade_master_league: "PvP Usta Lig",
    premade_common_combos: "Yaygın Kombolar",
    info_shadow_vs_nonshadow_title: "Gölge vs Gölge Olmayan",
    info_shadow_vs_nonshadow_text: "Pokémon GO Gölge ve Gölge Olmayan sürümleri aynı anda gösteremez. Ayrı aramalar kullanın.",
    info_master_league_title: "Usta Lig Sıralamaları",
    info_master_league_text: "Rekabetçi savaşlar için Usta Lig PvP sıralamalarına dayanır. Zacian (Taçlı Kılıç), Palkia (Köken ve Gölge), Zamazenta (Taçlı Kalkan), Dialga (Köken ve Gölge), Kyurem (Beyaz ve Siyah), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss ve Solgaleo gibi en üst sıralı Pokemon'ları içerir.",
    tier_s_label: "S Seviyesi",
    tier_s_description: "Gücün Zirvesi",
    tier_aplus_label: "A+ Seviyesi",
    tier_aplus_description: "Zirvede veya Zirveye Yakın Durur",
    tier_a_label: "A Seviyesi",
    tier_a_description: "Altın Standart Yatırım",
    badge_shadow: "GÖLGE",
    badge_mega: "MEGA",
    badge_mega_primal: "MEGA/İLKEL",
    premade_s_tier_shadows: "S Seviyesi Gölgeler",
    premade_s_tier_shadows_desc: "Gölge Pokemon - gücün zirvesi",
    premade_s_tier_nonshadow: "S Seviyesi Gölge Olmayan",
    premade_s_tier_nonshadow_desc: "Mega/Primal Pokemon - en yüksek öncelikler",
    premade_aplus_tier_shadows: "A+ Seviyesi Gölgeler",
    premade_aplus_tier_shadows_desc: "Gölge Pokemon - zirvede veya zirveye yakın durur",
    premade_aplus_tier_nonshadow: "A+ Seviyesi Gölge Olmayan",
    premade_aplus_tier_nonshadow_desc: "Mega Pokemon - zirvede veya zirveye yakın durur",
    premade_a_tier_shadows: "A Seviyesi Gölgeler",
    premade_a_tier_shadows_desc: "Gölge Pokemon - altın standart yatırım değeri",
    premade_a_tier_nonshadow: "A Seviyesi Gölge Olmayan",
    premade_a_tier_nonshadow_desc: "Mega Pokemon - altın standart yatırım değeri",
    premade_top25_master_league: "Top 25 Usta Lig",
    premade_top25_master_league_desc: "Usta Lig PvP rekabetçi savaşlar için en üst sıralı Pokemon'lar"
  },
  "Latin American Spanish": {
    app_title: "Constructor de Búsqueda Pokémon GO",
    app_subtitle: "Crea cadenas de búsqueda visualmente",
    search_string: "Cadena de Búsqueda",
    search_placeholder: "Tu cadena de búsqueda aparecerá aquí...",
    filter_search_placeholder: "Buscar filtros... (ej., 'shiny')",
    stats_ivs: "Estadísticas e IVs",
    types: "Tipos",
    special_status: "Estado Especial",
    evolution_buddy: "Evolución y Compañero",
    time_distance: "Tiempo y Distancia",
    size_gender: "Tamaño y Género",
    moves: "Movimientos",
    regions: "Regiones",
    clear_all: "Limpiar Todo",
    copy: "Copiar",
    copied: "¡Copiado!",
    copy_has_issues: "Copiar (Tiene problemas)",
    validation_error_title: "⚠️ Esta búsqueda no funcionará en Pokémon GO",
    validation_error_subtitle: "Estas combinaciones son imposibles, pero aún puedes copiar si quieres experimentar.",
    validation_why_label: "Por qué no funcionará:",
    validation_fix_label: "✓ Cómo arreglarlo:",
    filter_4star: "4★ (100% IV)",
    filter_3star: "3★ (82-98% IV)",
    filter_2star: "2★ (67-80% IV)",
    filter_1star: "1★ (51-64% IV)",
    filter_0star: "0★ (0-49% IV)",
    filter_4attack: "Ataque Perfecto (15)",
    filter_3attack: "Ataque Alto (12-14)",
    filter_4defense: "Defensa Perfecta (15)",
    filter_3defense: "Defensa Alta (12-14)",
    filter_4hp: "PS Perfectos (15)",
    filter_3hp: "PS Altos (12-14)",
    filter_0attack: "Ataque Cero",
    filter_0defense: "Defensa Cero",
    filter_0hp: "PS Cero",
    filter_shiny: "Brillante",
    filter_lucky: "Afortunado",
    filter_shadow: "Sombra",
    filter_purified: "Purificado",
    filter_legendary: "Legendario",
    filter_mythical: "Mítico",
    save_this_search: "Guardar esta búsqueda",
    search_saved: "¡Búsqueda guardada!",
    active: "activo",
    light_mode: "Modo claro",
    dark_mode: "Modo oscuro",
    translation_warnings: "Advertencias de Traducción:",
    conflicting_filters: "Filtros en Conflicto",
    remove_spaces: "Eliminar espacios de la cadena de búsqueda",
    missing_ampersand: "Falta & entre filtros",
    use_commas: "Usa comas entre números de Pokédex, no &",
    quick_searches: "Búsquedas Rápidas",
    cp_ranges: "Rangos de PC",
    pokemon_selection: "Selección de Pokémon",
    pokemon_groups: "Grupos de Pokémon",
    insert_cp_range: "Insertar rangos de PC para ligas PvP",
    quick_insert_pokemon: "Inserción rápida de rangos y grupos de Pokémon",
    saved_searches: "Búsquedas Guardadas",
    import_searches: "Importar búsquedas",
    export_searches: "Exportar búsquedas",
    delete_saved_search: "Eliminar búsqueda guardada",
    storage_limit_reached: "Límite de almacenamiento alcanzado. Por favor elimina algunas búsquedas guardadas.",
    failed_import: "Error al importar búsquedas guardadas. Por favor verifica el formato del archivo.",
    language: "Idioma",
    language_wip: "(WIP)",
    join_discord: "Únete al Discord para actualizaciones, sugerencias y reportes de errores",
    discord_link: "https://discord.gg/X9zqC3quKR",
    caught_today: "Capturado Hoy",
    last_7_days: "Últimos 7 Días",
    last_30_days: "Últimos 30 Días",
    last_week: "Última Semana",
    last_month: "Último Mes",
    last_year: "Último Año",
    custom_age: "Rango de Fecha Personalizado",
    today: "Hoy",
    more_than_days_ago: "Hace más de {days} días",
    days_ago: "Hace {start}-{end} días",
    last_days: "Últimos {days} días",
    age_label: "Edad {value}",
    distance_1000km_plus: "Distancia 1000km+",
    distance_100km_plus: "Distancia 100km+",
    include: "Incluir",
    exclude: "Excluir",
    custom_date_range: "Rango de Fecha Personalizado",
    examples: "Ejemplos",
    invalid_format: "Formato inválido. Use: número (ej., 30), rango (ej., 0-7), o formato edad (ej., age0-30)",
    generations: "Generaciones",
    pokemon_groups: "Grupos de Pokémon",
    gen_1_kanto: "Gen 1 (Kanto)",
    gen_2_johto: "Gen 2 (Johto)",
    gen_3_hoenn: "Gen 3 (Hoenn)",
    gen_4_sinnoh: "Gen 4 (Sinnoh)",
    gen_5_unova: "Gen 5 (Unova)",
    gen_6_kalos: "Gen 6 (Kalos)",
    gen_7_alola: "Gen 7 (Alola)",
    gen_8_galar: "Gen 8 (Galar)",
    all_starters: "Todos los Iniciales",
    kanto_starters: "Iniciales de Kanto",
    johto_starters: "Iniciales de Johto",
    hoenn_starters: "Iniciales de Hoenn",
    sinnoh_starters: "Iniciales de Sinnoh",
    unova_starters: "Iniciales de Unova",
    kalos_starters: "Iniciales de Kalos",
    alola_starters: "Iniciales de Alola",
    galar_starters: "Iniciales de Galar",
    pseudo_legendaries: "Pseudo-Legendarios",
    eeveelutions: "Eeveeluciones",
    quick_combos: "Combos Rápidos",
    quick_combos_info: "Estos botones agregan combinaciones de filtros a tu cadena de búsqueda existente, permitiéndote apilar múltiples combos juntos.",
    shiny_legendaries: "Legendarios Brillantes",
    shiny_legendaries_desc: "Todos los Pokémon legendarios brillantes",
    perfect_shadows: "Sombras Perfectas",
    perfect_shadows_desc: "Pokémon sombra con 100% IV",
    high_iv_non_shiny: "Alto IV No Brillante",
    high_iv_non_shiny_desc: "Pokémon 3-4★ que no son brillantes",
    trade_fodder: "Material de Intercambio",
    trade_fodder_desc: "Bajo IV no favoritos para intercambiar",
    recent_catches: "Capturas Recientes",
    recent_catches_desc: "Pokémon capturados en la última semana",
    evolution_ready: "Listo para Evolucionar",
    evolution_ready_desc: "Puede evolucionar, no favorito",
    shiny_costume: "Disfraz Brillante",
    shiny_costume_desc: "Pokémon brillantes con disfraces",
    legendary_non_shiny: "Legendario No Brillante",
    legendary_non_shiny_desc: "Legendarios que no has encontrado brillantes",
    pvp_league_cp_caps: "Límites de CP de Liga PvP",
    pvp_league_cp_caps_desc: "Estos son los límites de CP competitivos de las ligas PvP usados en Pokémon GO. Al hacer clic en un botón se insertará o reemplazará el rango de CP en tu cadena de búsqueda.",
    great_league: "Liga Principal",
    great_league_cp: "CP 0-1500",
    ultra_league: "Liga Ultra",
    ultra_league_cp: "CP 0-2500",
    master_league: "Liga Maestra",
    master_league_cp: "CP 2500+",
    under_500_cp: "Menos de 500 CP",
    under_500_cp_value: "CP 0-500",
    high_cp: "Alto CP",
    high_cp_value: "CP 3000+",
    perfect_cp: "CP Perfecto",
    perfect_cp_value: "CP 4000+",
    premade_section_title: "Niveles de incursión, PvP y combinaciones comunes",
    premade_pvp_competitive: "PvP y Competitivo",
    premade_raid_attackers: "Atacantes de Nivel de Incursión",
    premade_master_league: "PvP Liga Maestra",
    premade_common_combos: "Combinaciones Comunes",
    info_shadow_vs_nonshadow_title: "Shadow vs No-Shadow",
    info_shadow_vs_nonshadow_text: "Pokémon GO no puede mostrar versiones Shadow y no-Shadow simultáneamente. Usa búsquedas separadas.",
    info_master_league_title: "Clasificaciones de Liga Maestra",
    info_master_league_text: "Basado en las clasificaciones de PvP de Liga Maestra para combates competitivos. Incluye Pokémon mejor clasificados como Zacian (Espada Coronada), Palkia (Origen y Shadow), Zamazenta (Escudo Coronado), Dialga (Origen y Shadow), Kyurem (Blanco y Negro), Zekrom, Reshiram, Lugia, Metagross, Eternatus, Necrozma, Lunala, Ho-Oh, Groudon, Latios, Meloetta, Florges, Togekiss y Solgaleo.",
    tier_s_label: "Nivel S",
    tier_s_description: "Cúspide del Poder",
    tier_aplus_label: "Nivel A+",
    tier_aplus_description: "Se Mantienen en o Cerca de la Cima",
    tier_a_label: "Nivel A",
    tier_a_description: "Inversión Estándar de Oro",
    badge_shadow: "SOMBRA",
    badge_mega: "MEGA",
    badge_mega_primal: "MEGA/PRIMIGENIO",
    premade_s_tier_shadows: "Sombras Nivel S",
    premade_s_tier_shadows_desc: "Pokémon Shadow - cúspide del poder",
    premade_s_tier_nonshadow: "No-Shadow Nivel S",
    premade_s_tier_nonshadow_desc: "Pokémon Mega/Primal - máximas prioridades",
    premade_aplus_tier_shadows: "Sombras Nivel A+",
    premade_aplus_tier_shadows_desc: "Pokémon Shadow - se mantienen en o cerca de la cima",
    premade_aplus_tier_nonshadow: "No-Shadow Nivel A+",
    premade_aplus_tier_nonshadow_desc: "Pokémon Mega - se mantienen en o cerca de la cima",
    premade_a_tier_shadows: "Sombras Nivel A",
    premade_a_tier_shadows_desc: "Pokémon Shadow - estándar de oro digno de inversión",
    premade_a_tier_nonshadow: "No-Shadow Nivel A",
    premade_a_tier_nonshadow_desc: "Pokémon Mega - estándar de oro digno de inversión",
    premade_top25_master_league: "Top 25 Liga Maestra",
    premade_top25_master_league_desc: "Pokémon mejor clasificados para combates competitivos de PvP Liga Maestra"
  }
};

export const getUIText = (key, language) => {
  return UI_TRANSLATIONS[language]?.[key] || UI_TRANSLATIONS["English"][key] || key;
};

